<template>
  <div class="main-list-wrap pad0">

    <span class="loader h-100vh" v-if="(isFromLCAList && preFilling && (uploadlca == true || uploadlca == 'true'))"><img
        src="@/assets/images/main/loader.gif" />
    </span>
    <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--main-sidebar lca_scroll_hide"
      :class="{ 'lca-create-modal': isFromLCAList }" :settings="settings" @ps-scroll-y="scrollHandle">
      <!--
    <div class="lca_alert_wrap" v-if="getPetitionDetails.lcaId">
      <span class="lca_alert" v-if="getPetitionDetails.lcaId">LCA is already requested for the getPetitionDetails.</span>
    </div>
    -->
    
      <div :class="{ 'lca_scroll_cnt': isFromLCAList }">
        <template>
          <template
            v-if="(isFromLCAList || ([50].indexOf(getUserRoleId) > -1 || checkIsLcaExcuitive || (checkPetitionLcaRequiredandPermessions || tempReload) || !checkCurrentUrl))">
            <vs-alert
              v-if="(isFromLCAList && !this.checkProperty(this.getLcaDetails, '_id')) || (checkProperty(getPetitionDetails, 'lcaId') && getPetitionDetails.lcaId == null)"
              color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">NOTE: Make sure to upload the LCA if filed already. If not, fill
              in the form below to request for new LCA.

            </vs-alert>
            <div class="form_page pad0">
              <template>
                <div class="form_page_cnt">


                  <div class="form_section pad20 requestlca">

                    <form @submit.prevent>
                      <!-- <div class="tab-inner-content">
                    <div class="tabs-content-panel"> -->

                      <vs-col class="m-auto float-none pl-0 pr-0" vs-justify="center" vs-align="center">

                        <div class="form-container">

                          <div class="vx-row">
                            <div class="vx-col w-full">

                              <ul class="demo-alignment custom-radio mb-6" vs-type="flex" vs-align="center"
                                v-if="!checkProperty(this.getLcaDetails, '_id')">
                                <li @click="resetLca()" class="mt-0">
                                  <vs-radio v-model="uploadlca" vs-value="false">Request LCA</vs-radio>
                                </li>
                                <li @click="resetLca()" class="mt-0">
                                  <vs-radio v-model="uploadlca" vs-value="true">Upload Existing Filed/Certified
                                    LCA</vs-radio>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>



                        <div class="form-container">
                          <fileUploadNote :fileNote="true" v-if="(uploadlca == true || uploadlca == 'true') || (lcastatusSelected && checkProperty(lcastatusSelected, 'id'))"/>
                          <div class="vx-row">



                            <div class="vx-col md:w-1/2 w-full"
                              v-if="(uploadlca == true || uploadlca == 'true') || (lcastatusSelected && checkProperty(lcastatusSelected, 'id'))">
                              <div class="form_group">
                                <label class="form_label">Upload Existing Filed/Certified LCA<em>*</em></label>
                                <div class="vs-component">
                                  <!-- @input="upload(document)" -->
                                  <file-upload v-model="document" class="file-upload-input mb-0 fileupload_btn"
                                    :accept="pdfDocEntity" name="lcaDocument" :multiple="false" :hideSelected="true"
                                    data-vv-as="LCA document"  :fieldName="'document'"  :cid="'document'"
                                    :emitCategory="'document'"  @updateData="updateData"
                                   
                                    v-validate="{ 'required': (lcastatusSelected && (lcastatusSelected.id == 2 || lcastatusSelected.id == 3)) }">
                                    <!-- v-validate="{'required':(lcastatusSelected && lcastatusSelected.id == 2 || lcastatusSelected.id == 3)}"
                                -->
                                    <figure v-if="disabled_btn" class="loader loader2"><img
                                        src="@/assets/images/main/loader.gif" /></figure>
                                    <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                    Upload
                                  </file-upload>

                                  <span class="text-danger text-sm" style="margin-top: 0;"
                                    v-show="errors.has('lcaDocument')">{{ errors.first("lcaDocument") }}</span>
                                  <ul class="uploaded-list uploads_list no_bg mt-0">
                                    <li class="no_shadow" v-for="(item, index) in document" :key="index">
                                      {{ item.name }}
                                      <span style="cursor:pointer"
                                        @click="selectedStatusFromFile = false; remove(index, document)"> <i
                                          class="vs-icon notranslate icon-scale material-icons null">clear</i></span>
                                    </li>

                                  </ul>
                                </div>
                                <!-- <vs-upload text="Upload" class="file-upload" action="https://jsonplaceholder.typicode.com/posts/"
                                @on-success="successUpload" data-vv-as="Resume" />-->
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full "
                              v-if="(fileUploaded && (uploadlca == true || uploadlca == 'true'))">
                              <div class="form_group">
                                <label for class="form_label">LCA Status<em>*</em></label>
                                <div class="con-select">

                                  <multiselect name="lcastatus" v-validate="'required'" :close-on-select="true"
                                    :disabled="selectedStatusFromFile" v-model="lcastatusSelected" :show-labels="false"
                                    track-by="id" label="name" data-vv-as="LCA Status" placeholder="Select LCA Status"
                                    :options="lcastatuses" :multiple="false" :searchable="true" :allow-empty="false"
                                    @input="selectLcaStatus"></multiselect>
                                </div>
                                <span class="text-danger text-sm" v-show="errors.has('lcastatus')">
                                  {{ errors.first("lcastatus") }}
                                </span>
                              </div>
                            </div>
                            <template
                              v-if="(fileUploaded &&  (uploadlca == true || uploadlca == 'true')) || (uploadlca == false || uploadlca == 'false')">
                              
                           <template v-if="checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg'">
                              <redioButtonsBoolean @input="getCompanyDetails()" :required="true"  :defaultError="true"
                        :wrapclass="'md:w-1/2'" :cid="'internalEmployee'"  :fieldName="'internalEmployee'"  
                        v-model="lcaInfo.internalEmployee"  label="Inhouse Employment?" placeHolder="" />
                              
                              <div class="vx-col position-left" v-if="false" >
                                <div class="form_group">
                                  <label class="form_label">Inhouse Employment? </label>
                                  <div class="table_switch pt-2">

                                    <vs-switch v-model="lcaInfo.internalEmployee" @change="getCompanyDetails()">
                                      <span slot="on">Yes</span>
                                      <span slot="off">No</span>
                                    </vs-switch>
                                  </div>
                                </div>
                              </div>
                            </template>

                              
                              <div class="vx-col md:w-1/2 position-right" v-if="checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg'">
                                <div class="vx-row">
                                  <div class="vx-col w-full"
                                    :class="{ 'md:w-1/2': (isFromLCAList && getTenantTypeId != 2) && [50].indexOf(getUserRoleId) <= -1 }">
                                    <div class="form_group">
                                      <label class="form_label">End Client Name<em
                                          v-if="!lcaInfo.internalEmployee">*</em></label>
                                      <vs-input :key="'clientName'" class="w-full" v-validate="{ 'required': !lcaInfo.internalEmployee }"
                                        v-model="lcaInfo.clientName" data-vv-as="End Client Name" name="clientName"
                                        @keyup="updateEndClient()" />
                                      <span class="text-danger text-sm" v-show="errors.has('clientName')">{{
                                        errors.first("clientName") }}</span>
                                    </div>
                                  </div>                                
                                  <div class="vx-col md:w-1/2"
                                    v-if="(isFromLCAList && getTenantTypeId != 2) && [50].indexOf(getUserRoleId) <= -1 && checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg'">
                                    <div class="form_group">
                                      <label class="form_label">Petitioner<em>*</em> </label>
                                      <div class="con-select">
                                        <multiselect v-model="petitionerDetails" :options="petitionerList"
                                          :multiple="false" @input="updatedPetitionerDetails"
                                          :disabled="checkPetitionerDisable"
                                          v-validate="'required'" :hideSelected="true" :close-on-select="true"
                                          :clear-on-select="false" :preserve-search="true" data-vv-as="Petitioner"
                                          placeholder="Select Petitioner" label="name" track-by="name"
                                          :preselect-first="false" name="petitionerDetails">
                                          <!----@search-change="getPeritioners"-->
                                          <template slot="selection" slot-scope="{ values, isOpen }">
                                            <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{
                                              values.length }}
                                              Petitioners selected</span>
                                            <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                                          </template>
                                        </multiselect>
                                        <span class="text-danger text-sm" v-show="errors.has('petitionerDetails')">{{
                                          errors.first("petitionerDetails")
                                        }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>

                            </template>
                          </div>
                        </div>
                        <template
                          v-if="(fileUploaded && (uploadlca == true || uploadlca == 'true')) || (uploadlca == false || uploadlca == 'false')">
                          <div class="vx-row"
                            v-if=" checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg' && !checkProperty(lcaInfo, 'internalEmployee')
                             && ((checkProperty(getLcaDetails, 'allowToAddLCALayers')) 
                            || (checkProperty(configDetails, 'allowToAddLCALayers') && !checkProperty(getLcaDetails, '_id')))">
                            <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center">
                              <div class="form-container">
                                <h3 class="small-header mt-0">Client Relationship for Third Party Placements</h3>
                                <div class="vx-col w-full ep" v-if="!checkProperty(lcaInfo, 'internalEmployee')">
                                  <div class="form_group">
                                    <div class="vx-row external_employees pt-6">
                                      <!-----------First Item -->

                                      <template v-if="checkProperty(lcaInfo, 'layerInfo', 'length') > 0">
                                        <template v-for="(item, lindx) in lcaInfo['layerInfo']">

                                          <template v-if="checkProperty(item, 'layerType') == 'Employer/Petitioner'">
                                            <div class="external_employees_list default" :key="lindx">
                                              <div class="vx-col md:w-1/2 w-full">
                                                <div class="form_group">
                                                  <label class="form_label">Type<em>*</em></label>

                                                  <div class="con-select">

                                                    <multiselect v-validate="'required'" :name="'playerType' + lindx"
                                                      v-model="item.layerType" data-vv-as="Type" :show-labels="true"
                                                      :disabled="true" placeholder=" Type" :options="availableVendors"
                                                      :searchable="false" :allow-empty="false">
                                                    </multiselect>
                                                    <span class="text-danger text-sm"
                                                      v-show="errors.has('playerType' + lindx)">{{
                                                        errors.first("playerType" + lindx) }}</span>
                                                  </div>


                                                </div>
                                              </div>

                                              <div class="vx-col md:w-1/2 w-full">
                                                <div class="form_group">
                                                  <label class="form_label">Employer/Petitioner Name<em>*</em></label>
                                                  <vs-input  :disabled="(isFromLCAList && getTenantTypeId != 2) && [50].indexOf(getUserRoleId) <= -1" v-validate="'required'"
                                                    class="w-full" data-vv-as="Employer Name"
                                                    :name="'pemployerName' + lindx" v-model="item.employerName" />
                                                  <span class="text-danger text-sm"
                                                    v-show="errors.has('pemployerName' + lindx)">{{
                                                      errors.first("pemployerName" + lindx) }}</span>
                                                </div>
                                              </div>
                                            </div>
                                          </template>

                                        </template>
                                      </template>
                                      <!------Between Items removeVendor ,addVendor -->

                                      <template
                                        v-if="checkProperty(lcaInfo, 'betweenClients', 'length') > 0 && loadBetweens">
                                        <template v-for="(item, indx) in lcaInfo['betweenClients']">
                                          <template
                                            v-if="checkProperty(item, 'layerType') != 'Employer/Petitioner' && checkProperty(item, 'layerType') != 'End-client'">
                                            <div class="external_employees_list middle" :key="indx">
                                              <div class="vx-col md:w-1/2 w-full">
                                                <div class="form_group">
                                                  <label class="form_label">Vendor Type<em>*</em></label>

                                                  <div class="con-select">

                                                    <multiselect v-validate="'required'" :name="'layerType' + indx"
                                                      v-model="item.layerType" data-vv-as="Vendor Type"
                                                      :show-labels="true" @input="updateAvailableVendors"
                                                      placeholder="Vendor Type" :options="availableVendors"
                                                      :searchable="false" :allow-empty="false">
                                                    </multiselect>
                                                    <span class="text-danger text-sm"
                                                      v-show="errors.has('layerType' + indx)">{{
                                                        errors.first("layerType" + indx) }}</span>
                                                  </div>


                                                </div>
                                              </div>

                                              <div class="vx-col md:w-1/2 w-full">
                                                <div class="row_section">
                                                  <div class="form_group">
                                                    <label class="form_label">Vendor Name<em>*</em></label>
                                                    <vs-input  class="w-full" placeholde="Vendor Name"
                                                      v-validate="'required'" data-vv-as="Vendor Name"
                                                      :name="'employerName' + indx" v-model="item.employerName" />
                                                    <span class="text-danger text-sm"
                                                      v-show="errors.has('employerName' + indx)">{{
                                                        errors.first("employerName" + indx) }}</span>
                                                  </div>
                                                  <span @click="removeVendor(indx)" class="row_btn"><img
                                                      src="@/assets/images/main/delete-row-img.svg"></span>
                                                </div>
                                              </div>
                                            </div>
                                          </template>
                                        </template>

                                      </template>
                                      <button v-if="checkProperty(lcaInfo, 'betweenClients', 'length') < 3"
                                        @click="addVendor()" class="IB_primary-btn">Add Vendor</button>
                                      <!--------- --Last Item -->
                                      <template v-if="checkProperty(lcaInfo, 'layerInfo', 'length') > 1">
                                        <template v-for="(item, lindx) in lcaInfo['layerInfo']">
                                          <template v-if="checkProperty(item, 'layerType') == 'End-client'">
                                            <div class="external_employees_list default last-child" :key="lindx">
                                              <div class="vx-col md:w-1/2 w-full">
                                                <div class="form_group">
                                                  <label class="form_label"> Type<em>*</em></label>

                                                  <div class="con-select con-select2">

                                                    <multiselect :name="'endlayerType' + lindx" v-validate="'required'"
                                                      v-model="item.layerType" data-vv-as="End Client Type"
                                                      :show-labels="true" :disabled="true" placeholder="End Client Type"
                                                      :options="availableVendors" :searchable="false"
                                                      :allow-empty="false">
                                                    </multiselect>
                                                    <span class="text-danger text-sm"
                                                      v-show="errors.has('endlayerType' + lindx)">{{
                                                        errors.first("endlayerType" + lindx) }}</span>
                                                  </div>

                                                </div>
                                              </div>
                                              <div class="vx-col md:w-1/2 w-full ">
                                                <div class="form_group">
                                                  <label class="form_label">End Client Name<em>*</em></label>
                                                  <vs-input  :disabled="true" class="w-full custom-vs-component"
                                                    placeholder="End Client Name" data-vv-as="End Client Name"
                                                    :name="'endemployerName' + lindx" v-model="item.employerName" />
                                                  <span class="text-danger text-sm"
                                                    v-show="errors.has('endemployerName' + lindx)">{{
                                                      errors.first("endemployerName" + lindx) }}</span>
                                                </div>
                                              </div>
                                            </div>
                                          </template>

                                        </template>
                                      </template>


                                    </div>
                                  </div>
                                </div>
                              </div>
                            </vs-col>
                          </div>
                          
                          <div class="form-container">

                           
                            <div class="vx-row">
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <label class="form_label">Job Title<em>*</em></label>
                                  <vs-input :key="'jobTitle'" class="w-full" v-validate="'required|max:70'" name="jobTitle"
                                    data-vv-as="Job Title" v-model="lcaInfo.jobTitle" />
                                  <span class="text-danger text-sm" v-show="errors.has('jobTitle')">{{
                                    errors.first("jobTitle") }}</span>
                                </div>
                              </div>
                              <template v-if="checkProperty(getUserData, 'tenantDetails', 'slug') == 'slg'"  >
                                <div class="vx-col md:w-1/2"
                                    v-if="(isFromLCAList && getTenantTypeId != 2) && [50].indexOf(getUserRoleId) <= -1">
                                    <div class="form_group">
                                      <label class="form_label">Petitioner<em>*</em> </label>
                                      <div class="con-select">
                                        <multiselect v-model="petitionerDetails" :options="petitionerList"
                                          :multiple="false" @input="updatedPetitionerDetails"
                                          :disabled="checkPetitionerDisable"
                                          v-validate="'required'" :hideSelected="true" :close-on-select="true"
                                          :clear-on-select="false" :preserve-search="true" data-vv-as="Petitioner"
                                          placeholder="Select Petitioner" label="name" track-by="name"
                                          :preselect-first="false" name="petitionerDetails">
                                          <!----@search-change="getPeritioners"-->
                                          <template slot="selection" slot-scope="{ values, isOpen }">
                                            <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{
                                              values.length }}
                                              Petitioners selected</span>
                                            <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                                          </template>
                                        </multiselect>
                                        <span class="text-danger text-sm" v-show="errors.has('petitionerDetails')">{{
                                          errors.first("petitionerDetails")
                                        }}</span>
                                      </div>
                                    </div>
                                  </div>
                                <div class="vx-col  md:w-1/2" >
                                  <div class="form_group">
                                    <label class="form_label"> Choose appropriate SOC Code <em >{{isSlg&&[50].indexOf(getUserRoleId) > -1?'':'*'}}</em></label>
                                    <div class="con-select">
                                      <multiselect name="preferredsoccode" v-model="lcaInfo.preferredSocDetails"
                                        :options="masterSocList" :multiple="false" :close-on-select="true"
                                        :clear-on-select="false" :preserve-search="true" placeholder=" Choose appropriate SOC Code "
                                        label="name" track-by="id" :preselect-first="false" data-vv-as="Choose appropriate SOC Code"
                                        v-validate="isSlg&&[50].indexOf(getUserRoleId) > -1?'':'required'">
                                        <template slot="selection" slot-scope="{ values, isOpen }">
                                          <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{
                                            values.length }} SOC(s) Selected</span>
                                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                                        </template>
                                      </multiselect>
                                      <span class="text-danger text-sm" v-show="errors.has('preferredsoccode')">{{
                                        errors.first("preferredsoccode") }} </span>






                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" >
                                  <div class="form_group">
                                    <label class="form_label">Offered Wage<em>*</em></label>
                                    <vs-input :key="'Salary'" class="w-full" v-validate="'required|max:70'" name="Salary"
                                      data-vv-as="Offered Wage" v-model="lcaInfo.salary" :maxLength="15"
                                      oninput="this.value = this.value.replace(/[^0-9 .]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');" />
                                    <span class="text-danger text-sm" v-show="errors.has('Salary')">{{
                                      errors.first("Salary") }}</span>
                                  </div>
                                </div>
                                <datepickerField @input="updateEmpEndDate($event)" wrapclass="md:w-1/2"
                                v-model="lcaInfo.empStartDate" :fieldName="'Employment Start Date'"
                                label="Employment Start Date" :validationRequired="true" />

                                <datepickerField wrapclass="md:w-1/2" v-model="lcaInfo.empEndDate"
                                  :dateEnableFrom="lcaInfo.empStartDate" :fieldName="'Employment End Date'"
                                  label="Employment End Date" :validationRequired="true" />

                                  
                                  <redioButtonsBoolean @input="fullTimePositionChanged()" :required="true"  :defaultError="true"
                        :wrapclass="'md:w-1/2'" :cid="'fullTimePosition'"  :fieldName="'fullTimePosition'"  
                        v-model="lcaInfo.fullTimePosition"  label="Is this a full-time position?" placeHolder="" />
                        <div class="vx-col position-right">
                                <div class="form_group">
                                  <label class="form_label">How many hours per week for the position? <em
                                      v-if="!lcaInfo.fullTimePosition">*</em></label>
                                  <vs-input :key="'hoursPerWeek'" class="w-full" :disabled="lcaInfo.fullTimePosition"
                                    v-validate="{ 'required': !lcaInfo.fullTimePosition, 'numeric': true }" maxLength="2"
                                    name="hoursPerWeek" data-vv-as="Hours Per Week" v-model="lcaInfo.hoursPerWeek"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');" />
                                  <span class="text-danger text-sm" v-show="errors.has('hoursPerWeek')">{{
                                    errors.first("hoursPerWeek") }}</span>
                                </div>
                                </div>
                       
                              </template>
                              <div class="vx-col md:w-1/2 w-full"
                                v-if=" checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg' &&
                                ((checkProperty(getLcaDetails, 'yearsOfExpRequiredForLCA') == true) 
                                || (checkProperty(configDetails, 'yearsOfExpRequiredForLCA') == true && !checkProperty(getLcaDetails, '_id')))">
                                <div class="form_group">
                                  <label class="form_label">No of years of experience in related field </label>
                                  <vs-input :key="'totalExpInYears'"
                                    oninput="this.value = this.value.replace(/[^0-9 .]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                    maxLength="5" class="w-full" data-vv-as="Field Experience" name="totalExpInYears"
                                    v-model="lcaInfo.totalExpInYears" />
                                  <span class="text-danger text-sm" v-show="errors.has('totalExpInYears')">{{
                                    errors.first("totalExpInYears") }}</span>
                                </div>
                              </div>
                            </div>
                              <!-- <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="reference_links">
                                    <a href="https://www.onetonline.org/find/all" target="_blank" class="download_all">
                                      ONet Ref. URL
                                      <img src="@/assets/images/main/external_link.png">
                                    </a>
                                    <a href="https://www.bls.gov/ooh/" target="_blank" class="download_all">
                                      OOH Ref. URL
                                      <img src="@/assets/images/main/external_link.png">
                                    </a>
                                  </div> 
                                </div>
                              </div> -->
                              <div class="job_duty_wrapper">
                                <template v-if="checkProperty(getUserData, 'tenantDetails', 'slug') == 'slg'">
                                  <div class="vx-row">
                                    <div class="vx-col w-full">
                                      <div class="form_group mb-6 mt-0">
                                        <label class="form_label" >Job Duties<em >*</em></label>
                                        <ckeditor data-vv-as="Job Duties" name="jobduties" v-validate="'required'"
                                          :editor="editor" v-model="lcaInfo.jobDuties" :config="editorConfig" />

                                        <span class="text-danger text-sm" v-show="errors.has('jobduties')">{{
                                          errors.first("jobduties") }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                    <template v-if="( checkProperty(getLcaDetails, 'multipleJobDutiesForLCA') == true) || (checkProperty(configDetails, 'multipleJobDutiesForLCA') == true && !checkProperty(getLcaDetails, '_id'))"  >
                                      <div class="vx-row job_duties_parent">
                                        <vs-col class="w-full p-0 mb-6 mt-2" v-if="canRenderField('h4EadPhotoEmailStmt', fieldsArray ,false,tplsection)">
                                        <vs-alert
                                          color="warning"
                                          class="warning-alert top-warning-alert"
                                          icon-pack="IntakePortal"
                                          icon="IP-information-button"
                                          active="true"
                                        >
                                          NOTE: Please fill in at least 8 points as listed below individually to 
                                          explain the job duties better. This will help all stakeholders to understand 
                                          the requirement in detail, match with skills of respective Beneficiary and avoid any
                                          unwanted delays in case processing
                                        </vs-alert>
                                        </vs-col>
                                        <div class="job_duties_header">
                                          <label class="form_label">Job Duties<em>*</em></label>
                                          <div class="reference_links_v2">
                                            <a href="https://www.onetonline.org/find/all" target="_blank" class="download_all">
                                              ONet Ref. URL
                                              <img src="@/assets/images/main/external_link_red.png">
                                            </a>
                                            <a href="https://www.bls.gov/ooh/" target="_blank" class="download_all">
                                              OOH Ref. URL
                                              <img src="@/assets/images/main/external_link_red.png">
                                            </a>
                                          </div>
                                        </div>
                                        <template v-for="( JobDuti ,jind) in lcaInfo['multiJobDuties']" >
                                          <div class="vx-col w-full job_duties_bg" :key="jind" :class="{'border_top': checkProperty(lcaInfo ,'multiJobDuties','length')>1}">
                                            <div class="form_group">
                                              <label v-if="false" class="form_label">Job Duties<em>*</em></label>
                                              <!----
                                              <ckeditor data-vv-as="Job Duties" :name="'jobduties'+jind" v-validate="'required'"
                                                :editor="editor" v-model="JobDuti.content" :config="editorConfig" />
                                                --->
                                                <vs-textarea
                                                
                                                :data-vv-as="'Job Duty '+(jind + 1)" 
                                                :name="'jobduties'+jind"
                                                v-validate="'required'"
                                                :placeholder="'Job Duty ' + (jind + 1)"
                                                v-model="JobDuti.content"
                                            
                                              class="w-full m-0"
                                            />

                                              <span class="text-danger text-sm " v-show="errors.has('jobduties'+jind)">{{
                                                errors.first('jobduties'+jind) }}</span>
                                            </div>
                                            <template v-if="false"  >
                                              <button v-if="(checkProperty(lcaInfo , 'multiJobDuties' ,'length') -1 ) ==jind" class="IB_primary-btn mb-6" @click="addJobDuty()" >
                                                Add More
                                              </button>
                                              <button class="job_duties_delete" v-if="checkProperty(lcaInfo ,'multiJobDuties','length')>1"  @click="removeJobDuty(jind)"  ></button>
                                            
                                            </template>
                                          </div>
                                      
                                        </template> 
                                      </div>
                                    </template>
                                  <template >
                                    <div class="vx-row">
                                      <div class="vx-col w-full">
                                        <div class="form_group mb-6 mt-0">
                                          <label class="form_label" v-if="!((checkProperty(getLcaDetails, 'multipleJobDutiesForLCA') == true) || (checkProperty(configDetails, 'multipleJobDutiesForLCA') == true && !checkProperty(getLcaDetails, '_id')))"  >Job Duties<em >*</em></label>
                                          <!-- <vs-textarea
                                            v-validate="'required'"
                                            name="jobduties"
                                            data-vv-as="Job Duties"
                                            v-model="lcaInfo.jobDuties"
                                            class="w-full"
                                          /> -->
                                          <!-- <ckeditor data-vv-as="Job Duties" name="jobduties" v-validate="!((checkProperty(getLcaDetails, 'multipleJobDutiesForLCA') == true) || (checkProperty(configDetails, 'multipleJobDutiesForLCA') == true && !checkProperty(getLcaDetails, '_id')))?'required':''"
                                            :editor="editor" v-model="lcaInfo.jobDuties" :config="editorConfig" />
                                          <span class="text-danger text-sm" v-show="errors.has('jobduties')">{{
                                            errors.first("jobduties") }}</span> -->
                                            <quillTextEditor  :fieldName="'jobduties'" :required="!((checkProperty(getLcaDetails, 'multipleJobDutiesForLCA') == true) || (checkProperty(configDetails, 'multipleJobDutiesForLCA') == true && !checkProperty(getLcaDetails, '_id')))?true:false" :tplsection="'jobduties'" :tplkey="'jobduties'" :cid="'jobduties'"
                                            :customValidNotRequire="false" v-model="lcaInfo.jobDuties" :canSpellCheck="true" :vvas="'Job Duties'"/>
                                        </div>
                                      </div>
                                  </div>
                                  </template>
                                </template>
                              </div>
                              
                              <div class="vx-row" v-if="checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg' ">
                              <datepickerField @input="updateEmpEndDate($event)" wrapclass="md:w-1/2"
                                v-model="lcaInfo.empStartDate" :fieldName="'Employment Start Date'"
                                label="Employment Start Date" :validationRequired="true" />

                              <datepickerField wrapclass="md:w-1/2" v-model="lcaInfo.empEndDate"
                                :dateEnableFrom="lcaInfo.empStartDate" :fieldName="'Employment End Date'"
                                label="Employment End Date" :validationRequired="true" />


                              <div class="vx-col md:w-1/3 w-full ">
                                <div class="form_group">
                                  <label for class="form_label">Wage Level<em>*</em></label>
                                  <div class="con-select">
                                    <multiselect name="selectedWage" v-validate="'required'" v-model="selectedWage"
                                      @select="selectWage" :show-labels="false" track-by="id" label="name"
                                      data-vv-as="Wage" placeholder="Select" :multiple="false" :options="all_wage_lavels"
                                      :searchable="true" :close-on-select="true" :allow-empty="required"></multiselect>
                                    <span class="text-danger text-sm" v-if="errors.has('selectedWage')">* Wage Level is
                                      required </span>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-2/3 w-full d-flex align-items-start"
                              v-if="checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg'">
                                <div class="form_group custom_filed w-2/3">
                                  <label class="form_label">Salary<em>*</em></label>
                                  <vs-input :key="'salary'" maxLength="10" name="salary" v-validate="'required|max:12'" class="w-full"
                                    data-vv-as="Salary" v-model="lcaInfo.salary"
                                    oninput="this.value = this.value.replace(/[^0-9 .]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');" />
                                  <span class="text-danger text-sm nowrap" v-show="errors.has('salary')">{{
                                    errors.first("salary") }}</span>
                                </div>


                                <div class="form_group custom_filed w-1/3">
                                  <label for class="form_label">&nbsp;</label>
                                  <div class="con-select">
                                    <multiselect name="payFrequency" v-validate="'required'"
                                      v-model="lcaInfo.payFrequency" :show-labels="false" data-vv-as="Pay Frequency"
                                      placeholder="Frequency" :multiple="false" :options="payFrequencyList"
                                      :searchable="true" :close-on-select="true" :allow-empty="required"></multiselect>
                                    <span class="text-danger text-sm" v-show="errors.has('payFrequency')">{{
                                      errors.first("payFrequency") }}</span>

                                  </div>

                                </div>
                              </div>

                              <redioButtonsBoolean @input="fullTimePositionChanged()" :required="true"  :defaultError="true"
                        :wrapclass="'md:w-1/2'" :cid="'fullTimePosition'"  :fieldName="'fullTimePosition'"  
                        v-model="lcaInfo.fullTimePosition"  label="Is this a full-time position?" placeHolder="" />
                       

                              <div class="vx-col position-left" v-if="false">
                                <div class="form_group">
                                  <label class="form_label">Is this a full-time position?<em>*</em></label>
                                  <div class="table_switch pt-2">

                                    <vs-switch @input="fullTimePositionChanged()" v-model="lcaInfo.fullTimePosition">
                                      <span slot="on">Yes</span>
                                      <span slot="off">No</span>
                                    </vs-switch>
                                  </div>



                                </div>
                              </div>

                              <div class="vx-col position-right">
                                <div class="form_group">
                                  <label class="form_label">How many hours per week for the position? <em
                                      v-if="!lcaInfo.fullTimePosition">*</em></label>
                                  <vs-input :key="'hoursPerWeek'" class="w-full" :disabled="lcaInfo.fullTimePosition"
                                    v-validate="{ 'required': !lcaInfo.fullTimePosition, 'numeric': true }" maxLength="2"
                                    name="hoursPerWeek" data-vv-as="Hours Per Week" v-model="lcaInfo.hoursPerWeek"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');" />
                                  <span class="text-danger text-sm" v-show="errors.has('hoursPerWeek')">{{
                                    errors.first("hoursPerWeek") }}</span>
                                </div>
                              </div>

                              <template v-if="fileUploaded && uploadlca == 'true'">
                                <div class="vx-col w-full md:w-1/2">
                                  <div class="form_group">
                                    <label class="form_label">DOL Reference Number<em>*</em></label>
                                    <vs-input :key="'dolref'" maxLength="25" class="w-full" v-validate="'required'" name="dolref"
                                      data-vv-as="DOL Reference Number" v-model="lcaInfo.docref" />
                                    <span class="text-danger text-sm" v-show="errors.has('dolref')">{{
                                      errors.first("dolref") }}</span>
                                  </div>
                                </div>



                                <datepickerField v-if="checkProperty(lcastatusSelected, 'name')" wrapclass="md:w-1/2"
                                  v-model="lcaStatusDate" :dateEnableTo="new Date()" :fieldName="lcaStatusDate"
                                  :vvas="'Date'" :label="selectLcaStatusDate" :validationRequired="true" />
                                <div class="vx-col md:w-1/2  " v-if="false && checkProperty(lcastatusSelected, 'name')">



                                  <div class="form_group">
                                    <label class="form_label">
                                      <template>{{ checkProperty(lcastatusSelected, 'name') }} Date</template>
                                      <em>*</em></label>

                                    <div class="vs-component">
                                      <datepicker :typeable="true" name="statusDate"
                                        :disabled-dates="{ from: new Date() }" v-validate="'required'"
                                        v-model="lcaStatusDate"
                                        :data-vv-as="checkProperty(lcastatusSelected, 'name') + ' Date'"
                                        placeholder="DD/MM/YYYY"></datepicker>
                                      <span class="text-danger text-sm" v-show="errors.has('statusDate')">
                                        {{ checkProperty(lcastatusSelected, 'name') + ' Date is required' }}
                                      </span>
                                    </div>
                                  </div>


                                </div>
                              </template> 
                             <template   >
                              <div class="vx-col"
                              
                                :class="{ ' md:w-1/2  ': uploadlca == 'true', ' w-full ': uploadlca == 'false' }"
                                v-if="uploadlca == 'false' && !checkProperty(this.getLcaDetails, '_id')">
                                <div class="form_group">
                                  <label class="form_label"> Preferred SOC Code <em v-if="( checkProperty(getLcaDetails, 'preSOCCodeMandatoryLCA') == true) || (checkProperty(configDetails, 'preSOCCodeMandatoryLCA') == true && !checkProperty(getLcaDetails, '_id'))||(isSlg&&[50].indexOf(getUserRoleId) <= -1)">*</em></label>

                                  <div class="con-select">




                                    <multiselect name="preferredsoccode" v-model="lcaInfo.preferredSocDetails"
                                      :options="masterSocList" :multiple="false" :close-on-select="true"
                                      :clear-on-select="false" :preserve-search="true" placeholder="Preferred  SOC Code "
                                      label="name" track-by="id" :preselect-first="false" data-vv-as="Preferred  SOC Code"
                                      v-validate="(( checkProperty(getLcaDetails, 'preSOCCodeMandatoryLCA') == true) || (checkProperty(configDetails, 'preSOCCodeMandatoryLCA') == true && !checkProperty(getLcaDetails, '_id'))||(isSlg&&[50].indexOf(getUserRoleId) <= -1))?'required':''">
                                      <template slot="selection" slot-scope="{ values, isOpen }">
                                        <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{
                                          values.length }} SOC(s) Selected</span>
                                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                                      </template>
                                    </multiselect>
                                    <span class="text-danger text-sm" v-show="errors.has('preferredsoccode')">{{
                                      errors.first("preferredsoccode") }} </span>






                                  </div>
                                </div>
                              </div>
                            </template>
                            
                              <div class="vx-col"
                                :class="{ ' md:w-1/2  ': uploadlca == 'true', ' w-full ': uploadlca == 'false' }"
                                v-if="uploadlca != 'false' && !checkProperty(this.getLcaDetails, '_id')">
                                <div class="form_group">
                                  <label class="form_label"><template> {{ uploadlca == 'false' ? 'Preferred' : 'Desired'
                                  }}
                                    </template> SOC Code<em>*</em></label>

                                  <div class="con-select">


                                    <multiselect name="dsocDetails" v-model="lcaInfo.socDetails" :options="masterSocList"
                                      :multiple="false" :close-on-select="true" :clear-on-select="false"
                                      :preserve-search="true" placeholder=" SOC Code" label="name" track-by="id"
                                      :preselect-first="false" data-vv-as="SOC Code" v-validate="'required'">
                                      <template slot="selection" slot-scope="{ values, isOpen }">
                                        <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{
                                          values.length }} SOC(s) Selected</span>
                                        <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                                      </template>
                                    </multiselect>
                                    <span class="text-danger text-sm" v-show="errors.has('dsocDetails')">{{
                                      errors.first("dsocDetails") }} </span>


                                  </div>
                                </div>
                              </div>





                            
                                  <div class="vx-col w-full"
                                  v-if="false && ((uploadlca == true || uploadlca == 'true') || (lcastatusSelected && checkProperty(lcastatusSelected, 'id')))">
                                  <div class="form_group">
                                    <label class="form_label">Upload Filed/Certified LCA<em>*</em></label>
                                    <div class="vs-component">
                                      <!-- @input="upload(document)" -->
                                      <file-upload v-model="document" class="file-upload-input mb-0 fileupload_btn"

                                        :accept="allDocEntity"  :emitCategory="'document'"  @updateData="updateData"
                                        name="lca-Document" :multiple="true" :hideSelected="true" data-vv-as="LCA document"
                                        v-validate="{ 'required': (lcastatusSelected && (lcastatusSelected.id == 2 || lcastatusSelected.id == 3)) }">
                                        <!-- v-validate="{'required':(lcastatusSelected && lcastatusSelected.id == 2 || lcastatusSelected.id == 3)}"
                                  -->
                                        <figure v-if="disabled_btn" class="loader loader2"><img
                                            src="@/assets/images/main/loader.gif" /></figure>
                                        <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                        Upload
                                      </file-upload>

                                      <span class="text-danger text-sm" style="margin-top: 0;"
                                        v-show="errors.has('lca-Document')">{{ errors.first("lca-Document") }}</span>
                                      <ul class="uploaded-list uploads_list no_bg mt-0">
                                        <li class="no_shadow" v-for="(item, index) in document" :key="index">
                                          {{ item.name }}
                                          <span style="cursor:pointer" @click="remove(index, document)"> <i
                                              class="vs-icon notranslate icon-scale material-icons null">clear</i></span>
                                        </li>

                                      </ul>
                                    </div>
                                    <!-- <vs-upload text="Upload" class="file-upload" action="https://jsonplaceholder.typicode.com/posts/"
                                  @on-success="successUpload" data-vv-as="Resume" />-->
                                  </div>
                                  </div>
                               
                             




                              <div class="divider mt-0"></div>
                            </div>


                            <div class="vx-row" v-if="checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg' || true ">
                              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center">
                                <div class="form-container">


                                  <template v-if="(checkProperty(getLcaDetails, 'multiEduDetailsForLCA') == true) || (checkProperty(configDetails, 'multiEduDetailsForLCA') == true && !checkProperty(getLcaDetails, '_id'))" >
                                    <h3 class="small-header mt-0">Educations</h3> 
                                    <template v-for="(edu ,eduind) in lcaInfo['educations']"  >
                                        <!----{ "mastersDegree": { "schoolName": "", "major": "" }, "highestDegree": null, "highestDegreeDetails": { "id": 3, "name": "" } } edu.highestDegree-->
                                        <div class="vx-row educations_more_bg" :key="eduind" :class="{'border_top': checkProperty(lcaInfo ,'educations','length')>1}">
                                          <h3 class="small-header mt-0 ml-4" v-if="false">Education</h3>  
                                          <div class="vx-col w-full">
                                            <div class="form_group">
                                              <label class="form_label">University/College/School Name<em>*</em></label>
                                              <vs-input class="w-full" v-validate="'required'"
                                                data-vv-as="University/College/School Name" :name="'eduschoolname'+eduind"
                                                v-model="edu.mastersDegree.schoolName" />
                                              <span class="text-danger text-sm" v-show="errors.has('eduschoolname'+eduind)">{{
                                                errors.first('eduschoolname'+eduind) }}</span>
                                            </div>
                                          </div>
                                    
                                          <div class="vx-col md:w-1/2 w-full ">
                                            <div class="form_group">
                                              <label for class="form_label">Qualification<em>*</em></label>
                                              <div class="con-select">
                                                <!-- @input="manageEducations" -->
                                                <multiselect
                                                 :preselect-first="false"
                                                v-validate="'required'"  
                                                 :name="'edsuhighestDegreeDetails'+eduind"
                                                  v-model="edu.highestDegreeDetails"
                                                   data-vv-as="Qualification"
                                                  :show-labels="true"
                                                   track-by="id" label="name"
                                                  placeholder="Select Qualification"
                                                   :options="masterEducationsList"
                                                  :searchable="true"
                                                   :allow-empty="false">
                                                </multiselect>
                                                <span class="text-danger text-sm" v-show="errors.has('edsuhighestDegreeDetails'+eduind)">{{
                                                  errors.first('edsuhighestDegreeDetails'+eduind) }}</span>

                                              </div>

                                            </div>
                                          </div>
                                          <div class="vx-col md:w-1/2 w-full">
                                            <div class="form_group">
                                              <label class="form_label">Major Field of Study<em>*</em></label>
                                              <vs-input  class="w-full" v-validate="'required'" data-vv-as="Major Field of Study"
                                                :name="'edumajor'+eduind" v-model="edu.mastersDegree.major" />
                                              <span class="text-danger text-sm" v-show="errors.has('edumajor'+eduind)">{{
                                                errors.first('edumajor'+eduind) }}</span>
                                            </div>
                                          </div>
                                          <div class="vx-col md:w-1/2 w-full">
                                           
                                       
                                      <button class="educations_delete" v-if="checkProperty(lcaInfo ,'educations','length')>1"  @click="removeEducation(eduind)"  ></button>
                                    
                                          </div>
                                 
                                        </div>
                                       </template>
                                        <!-- v-if=" checkProperty(educationsList, 'length') >0  && (checkProperty(lcaInfo , 'educations' ,'length') -1 ) ==eduind" -->
                                       <button class="IB_primary-btn mb-6" @click="addEducation()" >
                                        Add More
                                      </button>
                                  </template>
                                  <template v-else>
                                    <h3 class="small-header mt-0">Highest Education</h3>
                                    <div class="vx-row">
                                      <div class="vx-col w-full">
                                        <div class="form_group">
                                          <label class="form_label">University/College/School Name<em>*</em></label>
                                          <vs-input :key="'schoolname'" class="w-full" v-validate="'required'"
                                            data-vv-as="University/College/School Name" name="schoolname"
                                            v-model="lcaInfo.mastersDegree.schoolName" />
                                          <span class="text-danger text-sm" v-show="errors.has('schoolname')">{{
                                            errors.first("schoolname") }}</span>
                                        </div>
                                      </div>
                                      
                                        <div class="vx-col md:w-1/2 w-full ">
                                          <div class="form_group">
                                            <label for class="form_label">Qualification<em>*</em></label>
                                            <div class="con-select">

                                              <multiselect v-validate="'required'" name="highestDegreeDetails"
                                                v-model="lcaInfo.highestDegreeDetails" data-vv-as="Qualification"
                                                :show-labels="true" track-by="id" label="name"
                                                placeholder="Select Qualification" :options="education_types"
                                                :searchable="true" :allow-empty="false">
                                              </multiselect>
                                              <span class="text-danger text-sm" v-show="errors.has('highestDegreeDetails')">{{
                                                errors.first("highestDegreeDetails") }}</span>

                                            </div>

                                          </div>
                                        </div>
                                        <div class="vx-col md:w-1/2 w-full">
                                          <div class="form_group">
                                            <label class="form_label">Major Field of Study<em>*</em></label>
                                            <vs-input :key="'major'" class="w-full" v-validate="'required'" data-vv-as="Major Field of Study"
                                              name="major" v-model="lcaInfo.mastersDegree.major" />
                                            <span class="text-danger text-sm" v-show="errors.has('major')">{{
                                              errors.first("major") }}</span>
                                          </div>
                                        </div>
                                  
                                    </div>
                                  </template>
                                </div>
                              </vs-col>

                            </div>

                          </div>
                        </template>
                      </vs-col>

                      <template
                        v-if="(fileUploaded && checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg'&& (uploadlca == true || uploadlca == 'true')) || (uploadlca == false || uploadlca == 'false')">


                        <vs-col class="m-auto float-none pl-0 pr-0" vs-type="flex" vs-justify="center" vs-align="center"
                          vs-lg=" " vs-sm=" " v-if="lcaInfo.secondarlocation == '1' && false">
                          <div class="form-container">
                            <h3 class="small-header mt-0">Secondary Work Location</h3>
                            <div class="work-location-secondary">
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full pl-0">
                                  <div class="form_group">
                                    <label class="form_label">Work Company Name<em>*</em></label>
                                    <vs-input :key="'secondaryWorkAddressCompanyName'" class="w-full" v-validate="'required'" data-vv-as="Work Company Name"
                                      name="secondaryWorkAddressCompanyName"
                                      v-model="lcaInfo.secondaryWorkAddressCompanyName" />
                                    <span class="text-danger text-sm"
                                      v-show="errors.has('secondaryWorkAddressCompanyName')">{{
                                        errors.first("secondaryWorkAddressCompanyName") }}</span>
                                  </div>
                                </div>

                                <addressFields v-if="countries.length > 0 && lcaInfo.secondarlocation == '1'"
                                  :disableCountry="true" :addFormContainerCls="false" :validationRequired="true"
                                  :showaptType="true" :countries="countries" v-model="lcaInfo.secondaryWorkAddress"
                                  :cid="'Secondary_Work_Location'" />

                                <div class="vx-col md:w-1/2 w-full pad0" v-if="lcaInfo.workAddress.workLocation == '0'">
                                  <div class="custom-radio_wrap">
                                    <h6>Is this address Home Work Location?</h6>
                                    <ul class="custom-radio" vs-type="flex" vs-align="center">
                                      <li>
                                        <vs-radio @change="secondaryAddressAsHome()" vs-name="secondarlocation1"
                                          v-model="lcaInfo.secondaryWorkAddress.workLocation" vs-value="1">Yes</vs-radio>
                                      </li>
                                      <li>
                                        <vs-radio @change="secondaryAddressAsHome()" vs-name="secondarlocation1"
                                          v-model="lcaInfo.secondaryWorkAddress.workLocation" vs-value="0">No</vs-radio>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </vs-col>

                        <vs-col class="m-auto float-none pl-0 pr-0" vs-type="flex" vs-justify="center" vs-align="center"
                          vs-lg=" " vs-sm=" " v-if="checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg'">

                          <div class="form-container">

                            <div class="work-location-secondary">
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full pl-0">
                                  <div class="form_group">
                                    <label class="form_label">Total No of Employees<em>*</em></label>
                                    <vs-input :key="'noOfEmployeeOnYourPayroll'" maxLength="5" @input="CheckTotalEmpl"
                                      oninput="this.value = this.value.replace(/[^ 0-9 ]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                      class="w-full" v-validate="'required'" data-vv-as="Total No of Employees"
                                      name="noOfEmployeeOnYourPayroll" v-model="lcaInfo.noOfEmployeeOnYourPayroll" />
                                    <span class="text-danger text-sm" v-show="errors.has('noOfEmployeeOnYourPayroll')">{{
                                      errors.first("noOfEmployeeOnYourPayroll") }}</span>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full pr-0">
                                  <div class="form_group">
                                    <label class="form_label">Number of Employees on H1B or L1 <em>*</em></label>
                                    <vs-input :key="'noOfEmployeesOnH1bOrL1'" maxLength="5" @input="employeeCheck"
                                      oninput="this.value = this.value.replace(/[^ 0-9 ]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,''); "
                                      class="w-full" v-validate="'required'" data-vv-as="Number of Employees on H1B or L1"
                                      name="noOfEmployeesOnH1bOrL1" v-model="lcaInfo.noOfEmployeesOnH1bOrL1" />
                                    <span v-if="maxEmpError" class="text-danger text-sm">{{ maxEmpError }}</span>
                                    <span v-else-if="errors.has('noOfEmployeesOnH1bOrL1')" class="text-danger text-sm">{{
                                      errors.first("noOfEmployeesOnH1bOrL1") }}</span>
                                  </div>
                                </div>



                              </div>
                            </div>
                          </div>
                        </vs-col>


                        <div class="divider mt-0" v-if="checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg'"></div>

                        <vs-col v-if="countries.length > 0 && checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg'" class="m-auto float-none pl-0 pr-0" vs-type="flex"
                          vs-justify="center" vs-align="center" vs-lg=" " vs-sm=" ">
                          <div class="form-container addMoreAddress addMoreAddress_v2">
                            <div class="vx-row">
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <span class="address-field">Work Location <template v-if="lcaInfo['workAddresses'].length>1">1</template></span>
                                  <span style="margin-top:0px;" class="address-check"><vs-checkbox
                                      name="useEmployeeAdress"
                                      v-if="(lcaInfo.internalEmployee && (getTenantTypeId == 2 || ((isFromLCAList) || checkProperty(petitionDetails, 'companyDetails', '_id'))))"
                                      v-model="useEmployeeAdress" @input="internalEmployeeChanged()">Same as employer address</vs-checkbox></span>
                                </div>
                              </div>
                            </div>
                            <template v-if="checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg'">

                           
                            <template v-for="(addr, addind ) in lcaInfo['workAddresses']">
                              <div class="vx-row mar0 worklocation" :key="addind" :class="'location' + addind">
                                <span class="address-field" v-if="addind>0">Work Location {{ addind+1 }}</span>
                                
                                  <!-----addressEntityIOrHomeForLCA-->
                                  <!-- v-if="(checkProperty(getLcaDetails, 'addressEntityIOrHomeForLCA') == true) || (checkProperty(configDetails, 'addressEntityIOrHomeForLCA') == true && !checkProperty(getLcaDetails, '_id'))" -->
                                  <template >
                                <div class="vx-col w-full pad0" v-if="checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg'">
                                  <div class="form_group custom-radio_wrap">
                                    <label for="" class="vs-input--label">Address Type*</label>
                                    <ul class="custom-radio mt-1" vs-type="flex" vs-align="center">
                                      <!-- @change="setWorkLocation(addind)" -->
                                      <li>
                                        <vs-radio  :vs-name="'workLocation' + addind"
                                          v-model="addr.workLocation" :vs-value="'Employer'">Employer Office</vs-radio>
                                      </li>
                                      <li>
                                        <vs-radio :vs-name="'workLocation' + addind" v-model="addr.workLocation"
                                          :vs-value="'Client' ">Client Office</vs-radio>
                                      </li>
                                      <li>
                                        <vs-radio :vs-name="'workLocation' + addind" v-model="addr.workLocation"
                                          :vs-value="'Home'">Home Office</vs-radio>
                                      </li>
                                      <li>
                                        <vs-radio :vs-name="'workLocation' + addind" v-model="addr.workLocation"
                                          :vs-value="'Other'">Other</vs-radio>
                                      </li>
                                    </ul>
                                    <input type="hidden" :name="'AddressType'+ addind" v-validate="'required'" data-vv-as="Address Type"  v-model="addr.workLocation">
                                    <span class="text-danger text-sm" style="top:46px" v-show="errors.has('AddressType'+ addind)">{{errors.first('AddressType'+ addind) }}</span>
                                  </div>
                                </div>
                                <div v-if="addr.workLocation == 'Other' " class="vx-col w-full p-0">
                                  <div class="form_group">
                                    <label class="form_label">
                                      <template v-if="addr.workLocation"> Other Name<em>*</em></template>
                                     
                                    </label>
                                    <vs-input v-validate="'required'" class="w-full" data-vv-as="Other Name"
                                      :name="'workAddressCompanyName'+addind" v-model="addr.companyName" />
                                    <span class="text-danger text-sm" v-show="errors.has('workAddressCompanyName'+addind)">{{
                                      errors.first("workAddressCompanyName"+addind) }}</span>
                                  </div>
                                </div>
                                 </template>
                                 <addressFields :key="addind" :name="'PrimaryWork_Location'+addind"
                                  :disableCountry="true" :addFormContainerCls="false" :validationRequired="true"
                                  :showaptType="true" :countries="countries" v-model="lcaInfo['workAddresses'][addind]"
                                  :cid="'Primary_Work_Location'+addind" />
                                <span v-if="lcaInfo['workAddresses'].length > 1" @click="removeAddress(addind)"
                                  class="row_btn">
                                  <img src="@/assets/images/main/delete-row-img-white.svg">
                                </span>
                                <div
                                  v-if="lcaInfo['workAddresses'].length > 1 && addind != (lcaInfo['workAddresses'].length) - 1"
                                  class="divider full-divider m-0"></div>
                              </div>


                            </template>
                            <!-- <div class="divider mt-0"></div> -->
                            <div class="vx-col mar0 d-flex align-center mt-4">
                              <label class="address-field mb-0" style="font-size: 15px;">
                                If you have more than one location?
                              </label>
                              <button @click="addAddress()" class="IB_primary-btn"> Add Here</button>
                              <!-- <span @click="addAddress()" class="add-more">Add More</span> -->
                            </div>
                          </template>
                          </div>
                        </vs-col>
                        <div class="form-container" @click="otherDocsTemp=[]" v-if="checkProperty(getUserData, 'tenantDetails', 'slug') != 'slg'">
                              <div class="vx-row">
                                <div class="vx-col md:w-full">
                              <div class="form_group mart30">
                                <label class="form_label">Other Documents <strong class="ml-1">(eg: PAF, PWD)</strong></label>
                                <div class="vs-component mb-0">
                                  <!-- @input="uploadOther(otherDocsTemp,'others')" -->
                                  <file-upload v-model="otherDocsTemp" class="file-upload-input mb-0 fileupload_btn"
                                    :accept="allDocEntity" name="othersDocument" :multiple="true" :hideSelected="true"
                                    :emitCategory="'others'"  @updateData="updateData"
                                    :fieldName="'others'"  :cid="'others'"
                                    data-vv-as="LCA document" >
                                    <figure v-if="disabled_btn_others" class="loader loader2"><img
                                        src="@/assets/images/main/loader.gif" /></figure>
                                    <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                    Upload
                                  </file-upload>                                  
                                  <ul class="uploaded-list uploads_list no_bg mt-0">
                                    <li class="no_shadow" v-for="(item, index) in others" :key="index">
                                      <template >
                                        {{ item.name }}
                                      </template>
                                      
                                      <span style="cursor:pointer"
                                        @click="selectedStatusFromFile = false; remove_others(index, others)"> <i
                                          class="vs-icon notranslate icon-scale material-icons null">clear</i></span>
                                    </li>

                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <casedocumentslist :showTitle="false" @emitUploadingAction="emitUploadingAction" :docMainCategory="'documentsList'" :docslist="documentsList" :petition="petition" formscope="documentsform" :fieldsArray="[]" v-model="lcaInfo.documents" :tplsection="''"  :fieldName="''" ></casedocumentslist> -->
                      </template>
                      <template v-if="checkProperty(getUserData, 'tenantDetails', 'slug') == 'slg' ">
                        <template v-if="(fileUploaded && (uploadlca == true || uploadlca == 'true')) || (uploadlca == false || uploadlca == 'false')">
                        <vs-col v-if="countries.length > 0" class="m-auto float-none pl-0 pr-0" vs-type="flex"
                          vs-justify="center" vs-align="center" vs-lg=" " vs-sm=" ">
                          <div class="form-container addMoreAddress addMoreAddress_v2">
                            <div class="vx-row">
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <span class="address-field">Beneficiary's work locations  <template v-if="lcaInfo['workAddresses'].length>1">1</template></span>
                                  <span style="margin-top:0px;" class="address-check"><vs-checkbox
                                      name="useEmployeeAdress"
                                      v-if="(lcaInfo.internalEmployee && (getTenantTypeId == 2 || ((isFromLCAList) || checkProperty(petitionDetails, 'companyDetails', '_id'))))"
                                      v-model="useEmployeeAdress" @input="internalEmployeeChanged()">Same as employer address</vs-checkbox></span>
                                </div>
                              </div>
                            </div>

                            <template v-for="(addr, addind ) in lcaInfo['workAddresses']">
                              <div class="vx-row mar0 worklocation" :key="addind" :class="'location' + addind">
                                <span class="address-field" v-if="addind>0">Beneficiary's work locations {{ addind+1 }}</span>
                                  <template >
                                <div class="vx-col w-full pad0">
                                  <div class="form_group custom-radio_wrap">
                                    <label for="" class="vs-input--label">Address Type*</label>
                                    <ul class="custom-radio mt-1" vs-type="flex" vs-align="center"> 
                                      <!-- @change="setWorkLocation(addind)" @click="addEmployerAddress(addind)"   @click="addBeneficiaryAddress(addind)" -->
                                      
                                      <li >
                                        <vs-radio  :vs-name="'workLocatio' + addind" @input="addEmployerAddress(addind,'Employer')"  
                                          v-model="addr.workLocation" :vs-value="'Employer'">Employer Location</vs-radio>
                                      </li> 
                                      <li >
                                        <vs-radio :vs-name="'workLocatio' + addind" v-model="addr.workLocation"  @input="addBeneficiaryAddress(addind,'Client')" 
                                          :vs-value="'Client'">Beneficiary's home location</vs-radio>
                                      </li>
                                      <li>
                                        <vs-radio :vs-name="'workLocatio' + addind" v-model="addr.workLocation" @input="addOtherAddress(addind,'Other')"
                                          :vs-value="'Other'">Other work locations</vs-radio>
                                      </li>
                                    </ul>
                                    <input type="hidden" :name="'AddressTypeAddressType'+ addind" v-validate="'required'" data-vv-as="Address Type"  v-model="addr.workLocation">
                                    <span class="text-danger text-sm" style="top:46px" v-show="errors.has('AddressTypeAddressType'+ addind)">{{errors.first('AddressTypeAddressType'+ addind) }}</span>
                                  </div>
                                </div>
                                <div v-if="addr.workLocation == 'Other' " class="vx-col w-full p-0">
                                  <div class="form_group">
                                    <label class="form_label">
                                      <template v-if="addr.workLocation"> Other Name<em>*</em></template>
                                     
                                    </label>
                                    <vs-input  v-validate="'required'" class="w-full" data-vv-as="Other Name"
                                      :name="'workAddressCompanyName'+addind" v-model="addr.companyName" />
                                    <span class="text-danger text-sm" v-show="errors.has('workAddressCompanyName'+addind)">{{
                                      errors.first("workAddressCompanyName"+addind) }}</span>
                                  </div>
                                </div>
                                 </template>
                                 <addressFields :key="addind" :name="'PrimaryWork_Location'+addind"
                                  :disableCountry="true" :addFormContainerCls="false" :validationRequired="true"
                                  :showaptType="true" :countries="countries" v-model="lcaInfo['workAddresses'][addind]"
                                  :cid="'Primary_Work_Location'+addind" />
                                <span v-if="lcaInfo['workAddresses'].length > 1" @click="removeAddress(addind)"
                                  class="row_btn">
                                  <img src="@/assets/images/main/delete-row-img-white.svg">
                                </span>
                                <div
                                  v-if="lcaInfo['workAddresses'].length > 1 && addind != (lcaInfo['workAddresses'].length) - 1"
                                  class="divider full-divider m-0"></div>
                              </div>


                            </template>
                            <!-- <div class="divider mt-0"></div> -->
                            <div class="vx-col mar0 d-flex align-center mt-4 mb-8">
                              <label class="address-field mb-0" style="font-size: 15px;">
                                If you have more than one location?
                              </label>
                              <button @click="addAddress()" class="IB_primary-btn"> Add Here</button>
                              <!-- <span @click="addAddress()" class="add-more">Add More</span> -->
                            </div>

                          </div>
                        </vs-col>
                      </template>
                     

                     <template  v-if="(fileUploaded && (uploadlca == true || uploadlca == 'true')) || (uploadlca == false || uploadlca == 'false')">

                     <redioButtons
                     :required="true"
                     :defaultError="true"
                      :wrapclass="''" 
                      :cid="'everPetiWillfulViolator'" 
                       :fieldName="'everPetiWillfulViolator'"  
                        v-model="lcaInfo.everPetiWillfulViolator" 
                         label="Has the petitioner ever been found to be a willful violator?"
                          placeHolder=""
                           />
                           
                      
                        <redioButtons :wrapclass="''" 
                        :required="true"
                        :defaultError="true"
                        :cid="'everBenefiWorkOffsiteAtCompOrOrg'" 
                         :fieldName="'everBenefiWorkOffsiteAtCompOrOrg'"  
                        v-model="lcaInfo.everBenefiWorkOffsiteAtCompOrOrg" 
                         label="Will the beneficiary(ies) work for you off-site at another company or organization's location?"
                          placeHolder=""
                           />


                      
                        <redioButtons 
                        
                        :required="true"
                     :defaultError="true"
                        :wrapclass="''" :cid="'invPosiServicesThridPartEntity'"  :fieldName="'invPosiServicesThridPartEntity'"  
                        v-model="lcaInfo.invPosiServicesThridPartEntity"  label="Does the position involve providing services to a third party entity?" placeHolder="" />
                        <redioButtons
                        :required="true"
                        :defaultError="true"
                        :wrapclass="''" :cid="'invPosiBeneficiaryThridPartEntity'"  :fieldName="'invPosiBeneficiaryThridPartEntity'"  
                        v-model="lcaInfo.invPosiBeneficiaryThridPartEntity"  label="Does the position involve beneficiary working for a third party entity?" placeHolder="" />
                        <div class="form-container">
                        <div class="vx-row">
                          <div class="vx-col w-full md:w-1/2"  v-if="lcaInfo.invPosiBeneficiaryThridPartEntity == 'Yes'" >
                            <div class="form_group">
                              <label class="form_label">Client Name<em >*</em></label>
                              <vs-input :key="'clientName'" class="w-full" v-validate="'required'"
                                v-model="lcaInfo.clientName" data-vv-as="Client Name" name="clientName"
                                @keyup="updateEndClient()" />
                              <span class="text-danger text-sm" v-show="errors.has('clientName')">{{
                                errors.first("clientName") }}</span>
                            </div>
                          </div> 
                        </div>
                      </div>
                        <redioButtons
                        :required="true"
                        :defaultError="true"
                        :wrapclass="''"  v-if="checkProperty(lcaInfo,'invPosiBeneficiaryThridPartEntity') == 'Yes'"
                        :cid="'otherEntitiesInvPlacement'"  :fieldName="'otherEntitiesInvPlacement'"  
                        v-model="lcaInfo.otherEntitiesInvPlacement"  label="Are there any other entities involved in this placement?" placeHolder="" />
                        <div class="vx-row" 
                            v-if=" checkProperty(lcaInfo,'otherEntitiesInvPlacement') == 'Yes' && checkProperty(lcaInfo,'invPosiBeneficiaryThridPartEntity') == 'Yes'"  >
                            <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center">
                              <div class="form-container">
                                <h3 class="small-header mt-0">Client Relationship for Third Party Placements</h3>
                                <div class="vx-col w-full ep" >
                                  <div class="form_group">
                                    <div class="vx-row external_employees pt-6">
                                      <!-----------First Item -->

                                      <template v-if="checkProperty(lcaInfo, 'layerInfo', 'length') > 0">
                                        <template v-for="(item, lindx) in lcaInfo['layerInfo']">

                                          <template v-if="checkProperty(item, 'layerType') == 'Employer/Petitioner'">
                                            <div class="external_employees_list default" :key="lindx">
                                              <div class="vx-col md:w-1/2 w-full">
                                                <div class="form_group">
                                                  <label class="form_label">Type<em>*</em></label>

                                                  <div class="con-select">

                                                    <multiselect v-validate="'required'" :name="'playerType' + lindx"
                                                      v-model="item.layerType" data-vv-as="Type" :show-labels="true"
                                                      :disabled="true" placeholder=" Type" :options="availableVendors"
                                                      :searchable="false" :allow-empty="false">
                                                    </multiselect>
                                                    <span class="text-danger text-sm"
                                                      v-show="errors.has('playerType' + lindx)">{{
                                                        errors.first("playerType" + lindx) }}</span>
                                                  </div>


                                                </div>
                                              </div>

                                              <div class="vx-col md:w-1/2 w-full">
                                                <div class="form_group">
                                                  <label class="form_label">Employer/Petitioner Name<em>*</em></label>
                                                  <vs-input :disabled="(isFromLCAList && getTenantTypeId != 2) && [50].indexOf(getUserRoleId) <= -1" v-validate="'required'"
                                                    class="w-full" data-vv-as="Employer Name"
                                                    :name="'pemployerName' + lindx" v-model="item.employerName" />
                                                  <span class="text-danger text-sm"
                                                    v-show="errors.has('pemployerName' + lindx)">{{
                                                      errors.first("pemployerName" + lindx) }}</span>
                                                </div>
                                              </div>
                                            </div>
                                          </template>

                                        </template>
                                      </template>
                                      <!------Between Items removeVendor ,addVendor -->

                                      <template
                                        v-if="checkProperty(lcaInfo, 'betweenClients', 'length') > 0 && loadBetweens">
                                        <template v-for="(item, indx) in lcaInfo['betweenClients']">
                                          <template
                                            v-if="checkProperty(item, 'layerType') != 'Employer/Petitioner' && checkProperty(item, 'layerType') != 'End-client'">
                                            <div class="external_employees_list middle" :key="indx">
                                              <div class="vx-col md:w-1/2 w-full">
                                                <div class="form_group">
                                                  <label class="form_label">Vendor Type<em>*</em></label>

                                                  <div class="con-select">

                                                    <multiselect v-validate="'required'" :name="'layerType' + indx"
                                                      v-model="item.layerType" data-vv-as="Vendor Type"
                                                      :show-labels="true" @input="updateAvailableVendors"
                                                      placeholder="Vendor Type" :options="availableVendors"
                                                      :searchable="false" :allow-empty="false">
                                                    </multiselect>
                                                    <span class="text-danger text-sm"
                                                      v-show="errors.has('layerType' + indx)">{{
                                                        errors.first("layerType" + indx) }}</span>
                                                  </div>


                                                </div>
                                              </div>

                                              <div class="vx-col md:w-1/2 w-full">
                                                <div class="row_section">
                                                  <div class="form_group">
                                                    <label class="form_label">Vendor Name<em>*</em></label>
                                                    <vs-input  class="w-full" placeholde="Vendor Name"
                                                      v-validate="'required'" data-vv-as="Vendor Name"
                                                      :name="'employerName' + indx" v-model="item.employerName" />
                                                    <span class="text-danger text-sm"
                                                      v-show="errors.has('employerName' + indx)">{{
                                                        errors.first("employerName" + indx) }}</span>
                                                  </div>
                                                  <span @click="removeVendor(indx)" class="row_btn"><img
                                                      src="@/assets/images/main/delete-row-img.svg"></span>
                                                </div>
                                              </div>
                                            </div>
                                          </template>
                                        </template>

                                      </template>
                                      <button v-if="checkProperty(lcaInfo, 'betweenClients', 'length') < 3"
                                        @click="addVendor()" class="IB_primary-btn">Add Vendor</button>
                                      <!--------- --Last Item -->
                                      <template v-if="checkProperty(lcaInfo, 'layerInfo', 'length') > 1">
                                        <template v-for="(item, lindx) in lcaInfo['layerInfo']">
                                          <template v-if="checkProperty(item, 'layerType') == 'End-client'">
                                            <div class="external_employees_list default last-child" :key="lindx">
                                              <div class="vx-col md:w-1/2 w-full">
                                                <div class="form_group">
                                                  <label class="form_label"> Type<em>*</em></label>

                                                  <div class="con-select con-select2">

                                                    <multiselect :name="'endlayerType' + lindx" v-validate="'required'"
                                                      v-model="item.layerType" data-vv-as="End Client Type"
                                                      :show-labels="true" :disabled="true" placeholder="End Client Type"
                                                      :options="availableVendors" :searchable="false"
                                                      :allow-empty="false">
                                                    </multiselect>
                                                    <span class="text-danger text-sm"
                                                      v-show="errors.has('endlayerType' + lindx)">{{
                                                        errors.first("endlayerType" + lindx) }}</span>
                                                  </div>

                                                </div>
                                              </div>
                                              <div class="vx-col md:w-1/2 w-full ">
                                                <div class="form_group">
                                                  <label class="form_label">End Client Name<em>*</em></label>
                                                  <vs-input :key="'endemployerName' + lindx" :disabled="lcaInfo.invPosiBeneficiaryThridPartEntity == 'Yes' && lcaInfo.clientName !=''" class="w-full custom-vs-component"
                                                    placeholder="End Client Name" data-vv-as="End Client Name"
                                                    :name="'endemployerName' + lindx" v-model="item.employerName" />
                                                  <span class="text-danger text-sm"
                                                    v-show="errors.has('endemployerName' + lindx)">{{
                                                      errors.first("endemployerName" + lindx) }}</span>
                                                </div>
                                              </div>
                                            </div>
                                          </template>

                                        </template>
                                      </template>


                                    </div>
                                  </div>
                                </div>
                              </div>
                            </vs-col>
                          </div>
                      </template>
                      </template>
                      <div class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" v-if="([50,51].indexOf(getUserRoleId)>-1 || checkProperty($route, 'name') === 'fill-lca-anonymous-user')&&checkProperty(configDetails ,'acceptConsentAndTAndC')!=false">
                          <div class="form-container pt-0 px-0 form-container-questionnaire">
                            <div class="vx-row">
                              <div class="vx-col w-full mb-3">
                                <label class="switch-label"> <span @click="openConsentContent('termsAndConditions')" class="terms_n_cond_lbl">Terms and Conditions</span> and <span @click="openConsentContent('consent')" class="terms_n_cond_lbl">Consent </span>to the collection and processing of my personal data for immigration case(s), including any applicable necessary filings.</label>
                              </div>
                              <div class="vs-col">
                                  <div class="form_group custom-form-label custom-cx-box">
                                      <vs-checkbox
                                      v-model="consentChecked"
                                      data-vv-as="adjustmentOfI485Status"
                                      name="consentChecked">I have read and understand the above.
                                      </vs-checkbox>
                                  </div>
                                  <input type="hidden" :name="'select_PrimaryH1BHolder'" v-validate="'required'" data-vv-as="Field"
                                  v-model="getConsentVal">
                                  <span class="text-danger text-sm pt-3" style="top:46px"
                                  v-show="errors.has('select_PrimaryH1BHolder')">*You must read and understand the above</span>
                              </div>
                              <div class="vs-col">
                                  <div class="form_group custom-form-label custom-cx-box">
                                      <vs-checkbox
                                      v-model="termsAndConditionsChecked"
                                      data-vv-as="adjustmentOfI485Status"
                                      name="termsAndConditionsChecked">I agree to the above
                                      </vs-checkbox>
                                  </div>
                                  <input type="hidden" :name="'select_PrimaryH1BHoer'" v-validate="'required'" data-vv-as="Field"
                                  v-model="getTermsVal">
                                  <span class="text-danger text-sm pt-3" style="top:46px"
                                  v-show="errors.has('select_PrimaryH1BHoer')">*You must agree to the above</span>
                              </div>
                            </div>
                          </div>
                        </div>
                    </form>
                  </div>

                </div>
                <div class="tabs-content-footer mt-6 pr-1"
                  v-if="(!isFromLCAList && ((fileUploaded && (uploadlca == true || uploadlca == 'true')) || (uploadlca == false || uploadlca == 'false')))">

                  <template v-if="!(checkProperty(getPetitionDetails, 'lcaId'))">
                    <a class="btn" :disabled="disabled_btn" style="margin-right:20px;"
                      v-if="!(checkProperty(getPetitionDetails, 'lcaId')) &&  (uploadlca == false || uploadlca == 'false')" v-on:click="getCompanyDetailsForSubmition('saveLcaDraft')">Draft</a>
                    <a class="btn" :disabled="disabled_btn" style="margin-right:20px;"  
                      v-if="!(checkProperty(getPetitionDetails, 'lcaId'))" v-on:click="getCompanyDetailsForSubmition('saveOnlyLca')">Save LCA</a>
                    <a class="btn" :disabled="disabled_btn" style="margin-right:20px;"
                      v-if="(checkProperty(getPetitionDetails, 'questionnaireFilled')) && checkProperty($route, 'name') != 'fill-lca-anonymous-user' && checksubmitLawFirmSubmition"
                      v-on:click="getCompanyDetailsForSubmition('valiDateLcaRequest')">Submit </a>   
                  </template>
                  <!-- valiDateLcaRequest -->
                  <template v-else>
                    <vs-button v-if="(checkProperty(getPetitionDetails, 'lcaId'))" color="dark" class="btn cancel mr-3"
                      @click="goBack()" type="filled">Cancel</vs-button>
                      <a class="btn update_btn" :disabled="disabled_btn" style="margin-right:20px;"
                      v-if="checkProperty(getLcaDetails, 'statusId') ==99" v-on:click="getCompanyDetailsForSubmition('saveLcaDraft')">Draft</a>
                    <a class="btn update_btn" :disabled="disabled_btn" style="margin-right:20px;"
                      v-on:click="getCompanyDetailsForSubmition('updateLCaInfo')">  
                      <template v-if="checkProperty(getLcaDetails, 'statusId') ==99">Request</template>
                      <template v-else>Update</template>
                    </a>
                    <a class="btn update_btn" :disabled="disabled_btn" style="margin-right:20px;"
                    v-if="checkProperty(getPetitionDetails, 'questionnaireFilled') &&  checkProperty(getLcaDetails, 'statusId') ==99 && checksubmitLawFirmSubmition"
                      v-on:click="getCompanyDetailsForSubmition('valiDateLcaRequest')">Submit </a>
                  </template>
                </div>
                

                <div v-if="isFromLCAList" class="tabs-content-footer mt-6 pr-1">
                  <div class="popup-footer relative">
                    <span class="loader" v-if="updatingLca"><img src="@/assets/images/main/loader.gif" /></span>
                    <vs-button color="dark" class="cancel" type="filled" @click="goBack()">Cancel</vs-button>
                    <vs-button v-if="!this.checkProperty(this.getLcaDetails, '_id') || callFromActionPopup" color="success"
                      @click="getCompanyDetailsForSubmition('saveOnlyLca')" class="save" type="filled">Create 
                    </vs-button>
                    <vs-button v-if="(!this.checkProperty(this.getLcaDetails, '_id') || checkProperty(getLcaDetails, 'statusId') ==99) && (uploadlca == false || uploadlca == 'false') && !callFromActionPopup" color="success"
                      @click="getCompanyDetailsForSubmition('saveLcaDraft')" class="save" type="filled">Draft
                    </vs-button>

                    <!-- ;(false) -->
                    <vs-button v-if="this.checkProperty(this.getLcaDetails, '_id') && !callFromActionPopup" color="success"
                      @click="getCompanyDetailsForSubmition('updateLCaInfo')" class="save" type="filled">
                      <template v-if="checkProperty(getLcaDetails, 'statusId') ==99">Request</template>
                      <template v-else>Update</template>
                      
                    </vs-button>
                  </div>

                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="lca_alert_wrap">
              <span class="lca_alert">You don`t have permission to submit lca !</span>
            </div>

          </template>
        </template>
      </div>

    </VuePerfectScrollbar>

    <!-- <vs-popup class="holamundo main-popup cls-btn" :title="getLabelContent" :active.sync="showConsentContentPopup">
      <i class="manual_close" @click="showConsentContentPopup=false"></i>
      <div class="form-container"> 
        <div class="vx-row">  
          <div class="vx-col w-full" v-if="contentCategory == 'consent'">
              <p v-html="consentData" ></p>
          </div>
          <div class="vx-col w-full" v-if="contentCategory == 'termsAndConditions'">
              <p v-html="termsAndConditionsData" ></p>
          </div>
        </div>
      </div>
    </vs-popup> -->

    <modal
        name="showConsentContentPopup"
        classes="v-modal-sec"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="600px"
        height="auto"
        >
            <div class="v-modal profile_details_modal terms_n_conditions">
            <div class="popup-header fromDetailsPage">
                <h2 class="popup-title">{{getLabelContent}}</h2>
                <span  @click="$modal.hide('showConsentContentPopup')">
                <em class="material-icons">close</em>
                </span>
            </div>

            <div class="form-container"> 
                <div class="vx-row">
                    <div class="vx-col w-full" v-if="contentCategory == 'consent'">
                        <p class="ownership_details" v-html="consentData" ></p>
                    </div>
                    <div class="vx-col w-full" v-if="contentCategory == 'termsAndConditions'">
                        <p class="ownership_details" v-html="termsAndConditionsData" ></p>
                    </div>
                </div>
            </div>
            <!-- ;agreeTerms(contentCategory) -->
            <div class="popup-footer relative">
                <vs-button color="success"
                    @click="$modal.hide('showConsentContentPopup')"
                    class="save"
                    type="filled"
                    >Okay
                </vs-button>
            </div>

            </div>
        </modal>

    <vs-popup class="holamundo main-popup" title="Submit to Supervisor" :active.sync="SubmitParalegal">
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-search" icon-after label="Search Paralegal" />
          </div>
          <div class="vx-col w-full">
            <div class="form_group">
              <label class="form_label">Comments<em>*</em></label>
              <!-- <vs-textarea v-model="note_4"  class="w-full" /> -->
              <ckeditor v-model="note_4" class="w-full" :editor="editor" :config="editorConfig"></ckeditor>

            </div>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled">Cancel</vs-button>
        <vs-button color="success" class="save" type="filled">Save</vs-button>
      </div>
    </vs-popup>
    <vs-popup class="holamundo main-popup" title="Assign Paralegal" :active.sync="AssignParalegal">
      <div class="form-container">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input class="w-full" icon-pack="feather" icon="icon-search" icon-after label="Search Paralegal" />
          </div>
          <div class="vx-col w-full">
            <!-- <vs-textarea v-model="note_3" label="Comments…" class="w-full" /> -->
            <ckeditor v-model="note_3" label="Comments…" class="w-full" :editor="editor" :config="editorConfig">
            </ckeditor>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled">Cancel</vs-button>
        <vs-button color="success" class="save" type="filled">Assign</vs-button>
      </div>
    </vs-popup>
    <vs-popup class="holamundo success-popups" title="Your registration is complete." :active.sync="SuccessQuestionnaire">
      <figure>
        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
      </figure>
      <h2 class="title">
        USCIS receipt has been
        <br />sent to the Petitioner
      </h2>
    </vs-popup>

    <vs-popup class="holamundo success-popups" title="Questionnaire submitted successfully." :active.sync="submitedlca">
      <figure>
        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
      </figure>
      <!-- <h2 class="title">LCA request submitted successfully!</h2> -->
      <h2 class="title">{{ lca_request_msg }}</h2>

      <p>It will be reviewed by the Law Office and appropriate actions will be taken soon.</p>
    </vs-popup>
    <vs-popup class="holamundo main-popup" title=" Submit Case" :active.sync="showCommentPopup">

      <form data-vv-scope="activityfoform" @keyup="formErrors = ''" @click="formErrors = ''">
        <div class="form-container">
          <div class="vx-row">

            <div class="vx-col w-full">
              <div class="form_group mb-4">

                <label class="form_label">Comments<em>*</em></label>
                <!-- <vs-textarea
                  data-vv-as="Note"
                  v-validate="'required'"
                  v-model="comments"
                  name="comments"
                
                  class="w-full"
                /> -->
                <ckeditor data-vv-as="Note" v-validate="'required'" v-model="comments" name="comments" class="w-full"
                  :editor="editor" :config="editorConfig"></ckeditor>

                <span class="text-danger text-sm" v-show="errors.has('activityfoform.comments')">{{
                  errors.first("activityfoform.comments") }}</span>
              </div>
            </div>
          </div>
          <div class="text-danger text-sm formerrors mt-2" v-show="formErrors">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formErrors }}</vs-alert>
          </div>
        </div>
        <div class="popup-footer">
          <vs-button :disabled="(comments == '' || comments.trim() == '') || submtingForm" color="success"
            @click="submitAction()" class="save" type="filled">Submit</vs-button>
        </div>
      </form>

    </vs-popup>

    
    <vs-popup class="holamundo main-popup qcomment" :title="'Confirmation'" :active.sync="approveConformpopUp">
      
      <div class="form-container">

        <div class="vx-row">
          <div class="vx-col w-full">
            
            <p>{{documentExtractedMsg}}</p>
          </div>

        </div>

        

      </div>
      <div class="popup-footer">
        <vs-button color="dark" class="cancel" type="filled" @click="fillExtractedData(false)">Cancel </vs-button>
        <vs-button  color="success" class="save" type="filled" v-on:click.stop.prevent="fillExtractedData(true)">
          Continue
        </vs-button>
       
      </div>
    </vs-popup>
    <modal
          name="errorConfirmationModal"
          classes="v-modal-sec"
          :min-width="200"
          :min-height="200"
          :scrollable="true"
          :reset="true"
          width="650px"
          height="auto"
        >
        <div class="v-modal profile_details_modal error-modal-space" >
          <div class="popup-header fromDetailsPage">
            <h2 class="popup-title">
              Confirmation
            </h2>
          </div>
          <form data-vv-scope="addPaymentForm" class="relative" @submit.prevent @keydown.enter.prevent>
        <div
          class="popup_info">
         
          
        </div>
        <div class="form-container">
          {{employeeLcaMsg}}
        </div>
  
        <div class="popup-footer relative">
          <!-- <span class="loader"
            ><img src="@/assets/images/main/loader.gif"
          /></span> -->
          <vs-button
            color="dark"
            @click="closeConfirmationPopup(false)"
            class="cancel"
            type="filled"
            >No</vs-button>
          <vs-button
            color="success"
            @click="closeConfirmationPopup(true)"
            class="save"
            type="filled"
            >Yes 
          </vs-button>
        </div>
      </form>
          </div>
    </modal> 

  </div>
</template>
<script>
import fileUploadNote from "@/views/common/fileUploadNote.vue";
import redioButtonsBoolean from "@/views/forms/fields/redioButtonsBoolean.vue";
import redioButtons from "@/views/forms/fields/redioButtons.vue";
import casedocumentslist from "@/views/common/casedocuments.vue"
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moment from "moment";
import JQuery from "jquery";
import quillTextEditor from "./forms/fields/quillTextEditor.vue";
//import FileUpload from "vue-upload-component/src";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import * as _ from "lodash";
import Datepicker from "vuejs-datepicker-inv";
import { CheckIcon } from "vue-feather-icons";
import { XIcon } from "vue-feather-icons";
//import addressFields from "@/views/common/addressForm.vue";
import addressFields from "@/views/forms/fields/address.vue";
import { indexOf } from '@amcharts/amcharts4/.internal/core/utils/Array';
import Vue from 'vue';
Vue.use(CKEditor);
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import datepickerField from "@/views/forms/fields/datepicker.vue";
import FileUpload from "@/views/FileUpload.vue";

export default {
  computed: {
    getConsentVal(){
      let returnVal = '';
      if(this.consentChecked){
          returnVal = 'consentChecked';
      }
      return returnVal;
    },
    getTermsVal(){
      let returnVal = '';
      if(this.termsAndConditionsChecked){
          returnVal = 'termsAndConditionsChecked';
      }
      return returnVal;
    },
    getLabelContent(){
      let returnVal = '';
      if(this.contentCategory == 'consent'){
          returnVal = 'Consent to Process Personal Data';
      }
      if(this.contentCategory == 'termsAndConditions'){
          returnVal = 'Terms and Conditions';
      }
      return returnVal
    },
    checkPetitionerDisable(){
      let returnVal = false;
      if(this.getLcaDetails && this.checkProperty(this.getLcaDetails, '_id')){
        returnVal = true;
      }
      if(this.petitionerDetails && this.checkProperty(this.petitionerDetails, '_id') && this.callFromActionPopup && this.isFromLCAList){
        returnVal = true;
      }
      return returnVal
    },
    checkIsLcaExcuitive() {
     /// alert(this.checkProperty(this.petitionDetails.completedActivities.indexOf('ASSIGN_LCA_EXECUTIVE') > -1))
      let returnVal = false;
      if ([14].indexOf(this.getUserRoleId) > -1 &&  this.petitionDetails && this.checkProperty(this.petitionDetails ,"completedActivities" ,'length')>0){
        if(this.petitionDetails.completedActivities.indexOf('ASSIGN_LCA_EXECUTIVE') > -1){
          returnVal = true;
        }
        
      }
      return returnVal;
    },
    checksubmitLawFirmSubmition() {
      let returnVal = false;
      if (_.has(this.workFlowDetails, 'config')) {
        let adminsactiVityList = _.find(this.workFlowDetails.config, { "code": 'MANAGER_LIST' });
        let adminsList = []
        if (adminsactiVityList && adminsactiVityList.editors) {
          adminsList = _.map(adminsactiVityList.editors, 'roleId');
        }
        //SUBMIT_TO_LAW_FIRM
        let submitToLawFirmAvivity = _.find(this.workFlowDetails.config, { "code": 'SUBMIT_TO_LAW_FIRM' });
        let submitToLawFirmAvivityEditors = [];
        if (submitToLawFirmAvivity && submitToLawFirmAvivity.editors) {
          submitToLawFirmAvivityEditors = _.map(submitToLawFirmAvivity.editors, 'roleId');
        }
        if (adminsList.indexOf(this.getUserRoleId) > -1 || submitToLawFirmAvivityEditors.indexOf(this.getUserRoleId) > -1) {
          returnVal = true;
        }

      }
      return returnVal;

    }
  },
  components: {
    fileUploadNote,
    redioButtonsBoolean,
    redioButtons,
    casedocumentslist,
    datepickerField,
    addressFields,
    VuePerfectScrollbar,
    FileUpload,
    Datepicker,
    CheckIcon,
    XIcon,
    quillTextEditor
  },
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  props: {
    petitinId:{
      type:String,
      default:''  
    },
    callFromActionPopup:{
      type:Boolean,
      default:false
    },
    tplsection:{
                type: String,
                default: null,
            },
            fieldsArray: Array,
    petitionDetails: {
      type: Object,
      default: null
    },
    workFlowDetails: {
      type: Object,
      default: null,
    },
    isFromLCAList: {
      type: Boolean,
      default: false,
    },
    callFromDetails:{
      type: Boolean,
      default: false,
    }
  },
  methods: {
    agreeTerms(categ){
      if(categ == 'consent'){
          this.consentChecked=true;
      }
      if(categ == 'termsAndConditions'){
          this.termsAndConditionsChecked=true
      }
      this.$modal.hide('showConsentContentPopup');
    },
    getConsentDetails(){
      let path = '/global/get-consent-content';
      let payLoad = {
          tenantId:this.checkProperty( this.getUserData, 'tenantId')
      };
      this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((res)=>{
          if(res){
              if(res['consent']){
                  this.consentData = res['consent'];
              }
              if(res['termsAndConditions']){
                  this.termsAndConditionsData = res['termsAndConditions'];
              }
          }
      }).catch((err)=>{

      })
    },
    openConsentContent(category){
      this.getConsentDetails();
      let self = this;
      setTimeout(()=>{
          self.contentCategory = category;
          self.$modal.show('showConsentContentPopup')
      }, 1000)
      
        // this.showConsentContentPopup = true;
    },
    getCompanyDetailsForSubmition(callFrom=''){
      let returnVal = null;
      if (this.checkProperty(this.lcaInfo, 'noOfEmployeeOnYourPayroll') && this.checkProperty(this.getUserData, 'tenantDetails', 'slug') != 'slg') {
        let path = '/company/details';
        let data = { 'companyId': null };

        if (!this.isFromLCAList && _.has(this.petitionDetails, 'companyDetails', '_id')) {
          data['companyId'] = this.petitionDetails['companyDetails']['_id'];
          this.$store.dispatch('commonAction', { "data": data, 'path': path })
            .then((response) => {
              returnVal = response;
              this.checkLcaSubmition(returnVal, callFrom)
            })
            .catch((error) => {
              this.checkLcaSubmition('', callFrom)
            })
        }
        else if (this.isFromLCAList&&!this.checkProperty(this.getLcaDetails, '_id') && [50].indexOf(this.getUserRoleId) > -1) {
          data['companyId'] = this.getUserData['companyDetails']['_id'];
          this.$store.dispatch('commonAction', { "data": data, 'path': path })
            .then((response) => {
              returnVal = response;
              this.checkLcaSubmition(returnVal, callFrom)
            })
            .catch((error) => {
              this.checkLcaSubmition('', callFrom)
            })
        } else if (this.isFromLCAList&&!this.checkProperty(this.getLcaDetails, '_id') && [50, 51].indexOf(this.getUserRoleId) <= -1 && this.checkProperty(this.petitionerDetails, 'companyId')) {
          data['companyId'] = this.petitionerDetails['companyId'];
          this.$store.dispatch('commonAction', { "data": data, 'path': path })
            .then((response) => {
              returnVal = response;
              this.checkLcaSubmition(returnVal, callFrom)
            })
            .catch((error) => {
              this.checkLcaSubmition('', callFrom)
            })
        } else if (this.isFromLCAList&&this.checkProperty(this.getLcaDetails, '_id')&& this.checkProperty(this.petitionerDetails, 'companyId')) {
          data['companyId'] = this.petitionerDetails['companyId'];
          this.$store.dispatch('commonAction', { "data": data, 'path': path })
            .then((response) => {
              returnVal = response;
              this.checkLcaSubmition(returnVal, callFrom)
            })
            .catch((error) => {
              this.checkLcaSubmition('', callFrom)
            })
        }else{
          this.checkLcaSubmition('', callFrom)
        }
      }else{
        this.checkLcaSubmition('', callFrom)
      }
    },
    checkLcaSubmition(response, callFrom=''){
      this.selectedMethod = '';
      this.employeeLcaMsg = '';
      let companyPayroll = response
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updatingLca = true
          this.ValidLcaForm = true;
          if(this.checkProperty(this.lcaInfo, 'noOfEmployeeOnYourPayroll') && companyPayroll && this.checkProperty(companyPayroll, 'totalFullTimeEmployees')
          && this.checkProperty(this.getUserData, 'tenantDetails', 'slug') != 'slg'){
            let numberPayroll = parseInt(this.lcaInfo['noOfEmployeeOnYourPayroll']);
           let  pertitionerPayroll = parseInt(this.checkProperty(companyPayroll, 'totalFullTimeEmployees'))
            
            if(numberPayroll != pertitionerPayroll  ){
              this.$modal.show('errorConfirmationModal');
              this.selectedMethod = callFrom;
              this.employeeLcaMsg = 'Total number of employees ('+numberPayroll+ ') is different from the number from company profile ('+pertitionerPayroll+'). Are you sure to continue to update it?'
            }else{
              if(callFrom == 'saveOnlyLca'){
                this.saveOnlyLca();
              }
              if(callFrom == 'valiDateLcaRequest'){
                this.valiDateLcaRequest();
              }
              if(callFrom == 'updateLCaInfo'){
                if(this.isFromLCAList){
                  this.updateLCaInfo(false);
                }else{
                  this.updateLCaInfo(true);
                }
              }
              if(callFrom == 'saveLcaDraft'){
                if(this.isFromLCAList){
                  this.saveLcaDraft(false);
                }else{
                  this.saveLcaDraft(true);
                }
              }
            }
          }else{
            if(callFrom == 'saveOnlyLca'){
                this.saveOnlyLca();
              }
              if(callFrom == 'valiDateLcaRequest'){
                this.valiDateLcaRequest();
              }
              if(callFrom == 'updateLCaInfo'){
                if(this.isFromLCAList){
                  this.updateLCaInfo();
                }else{
                  this.updateLCaInfo(true);
                }
              }
              if(callFrom == 'saveLcaDraft'){
                if(this.isFromLCAList){
                  this.saveLcaDraft(false);
                }else{
                  this.saveLcaDraft(true);
                }
              }
          }
        }else {
        const $ = JQuery;
        $('html, body').animate({
          scrollTop: ($('.text-danger').first().offset().top)
        }, 500);
        }
      })
    },
    closeConfirmationPopup(submitLca = false){
      if(submitLca){
        if(this.selectedMethod == 'saveOnlyLca'){
          this.saveOnlyLca();
        }
        if(this.selectedMethod == 'valiDateLcaRequest'){
          this.valiDateLcaRequest();
        }
        if( this.selectedMethod == 'updateLCaInfo'){
          if(this.isFromLCAList){
            this.updateLCaInfo();
          }else{
            this.updateLCaInfo(true);
          }
        }
        this.$modal.hide('errorConfirmationModal');
      }else{
        this.updatingLca = false
        this.$modal.hide('errorConfirmationModal');
      }
    },
    updateData(docs, category){
      if(category == 'document'){
        this.document = docs;
        if(this.checkProperty(this.document, 'length')>0){
          this.$vs.loading();
          let doc = this.document[0];
          this.extractFileData(doc.path);
        }
      }
      if(category == 'others'){
        this.others = docs;
      }
    },
    getCompanyAddress(){
      let path = '/company/details';
        let data = { 'companyId': null };
        if (_.has(this.petitionDetails, 'companyDetails', '_id')) {
          data['companyId'] = this.petitionDetails['companyDetails']['_id'];
          this.$store.dispatch('commonAction', { "data": data, 'path': path })
            .then((response) => {
              this.companyAddressDetails = response;
            })
            .catch((error) => {

            })
        }
    },
    addOtherAddress(ind,val){
      let indexVal = ind;
      let newAddress = {
        "workLocation": val,
        companyName:'',
        line1: "",
        line2: "",
        zipcode: "",
        countryId: "231",
        stateId: "",
        locationId: "",
        "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
        stateDetails: null,
        locationDetails: null,
        aptType: ''
      }
      this.lcaInfo['workAddresses'] = _.map(this.lcaInfo['workAddresses'], (item, ind) => {
          if (ind == indexVal) {
           item = newAddress;
          }
         return item
        })
     
    }, 
    addBeneficiaryAddress(ind,val){
      let indexVal = ind;
      let newAddress = {
              "workLocation": val,
              line1: "",
              line2: "",
              zipcode: "",
              countryId: "231",
              stateId: "",
              locationId: "",
              "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
              stateDetails: null,
              locationDetails: null,
              aptType: ''
            }
            let self = this;
      if(_.has(this.petitionDetails, 'beneficiaryInfo') && _.has(this.petitionDetails['beneficiaryInfo'],'address') && this.checkProperty(this.petitionDetails, 'beneficiaryInfo','address')
      && this.checkProperty(this.petitionDetails['beneficiaryInfo'],'address', 'line1') ){
        let address = this.checkProperty(this.petitionDetails['beneficiaryInfo'],'address') 
        _.forEach(newAddress, (val, key) => {
          if (_.has(address, key) && self.checkProperty(address,key) ) {
            newAddress[key] = address[key];
          }
        
        })
      }
      this.lcaInfo['workAddresses'] = _.map(this.lcaInfo['workAddresses'], (item, ind) => {
          if (ind == indexVal) {
           item = newAddress;
          }
         return item
        })
     
    }, 
    addEmployerAddress(ind,val){
      let indexVal = ind;
      let newAddress = {
        "workLocation": val,
        line1: "",
        line2: "",
        zipcode: "",
        countryId: "231",
        stateId: "",
        locationId: "",
        "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
        stateDetails: null,
        locationDetails: null,
        aptType: ''
      }
      let self = this;
      if(_.has(this.companyAddressDetails, 'address') && this.checkProperty(this.companyAddressDetails,'address') && this.checkProperty(this.companyAddressDetails,'address', 'line1')){
        let address = this.checkProperty(this.companyAddressDetails,'address') 
        _.forEach(newAddress, (val, key) => {
          if (_.has(address, key) && self.checkProperty(address,key) ) {
            newAddress[key] = address[key];
          }
        
        })

      };
      //this.lcaInfo['workAddresses'][indexVal] = newAddress;
      //console.log(JSON.stringify(this.lcaInfo['workAddresses'][indexVal]))
      // if (_.has(this.companyAddressDetails, 'address') && this.checkProperty(this.companyAddressDetails,'address') && this.checkProperty(this.companyAddressDetails,'address', 'line1')) {
      //   newAddress = _.cloneDeep(this.checkProperty(this.companyAddressDetails,'address'));
      //   newAddress['companyName'] = '';
      //   newAddress['workLocation'] = '';
        
      // }
      this.lcaInfo['workAddresses'] = _.map(this.lcaInfo['workAddresses'], (item, ind) => {
          if (ind == indexVal) {
            item = newAddress;
          }
         return item
        })
       // console.log(JSON.stringify(this.lcaInfo['workAddresses'][indexVal]))
        

    },
    reload(){
      this.tempReload =true;
    },
    prepopulateEducations(){
      
      if(this.checkProperty(this.petitionDetails,'beneficiaryInfo','educations') && this.checkProperty(this.petitionDetails['beneficiaryInfo'],'educations','length')>0
      && this.checkProperty(this.petitionDetails['beneficiaryInfo']['educations'][0],'name') &&
      this.checkProperty(this.configDetails, 'multiEduDetailsForLCA') == true && !this.checkProperty(this.getLcaDetails, '_id')
      ){
        this.lcaInfo['educations'] = [];
        let obj={
          "mastersDegree": { "schoolName": "", "major": "" },
          "highestDegree": null,
          "highestDegreeDetails": null
        }
        _.forEach(this.petitionDetails['beneficiaryInfo']['educations'],(item)=>{
          obj={
            "mastersDegree": { "schoolName": "", "major": "" },
            "highestDegree": null,
            "highestDegreeDetails": null
          }
          obj['mastersDegree']['schoolName'] = item['name'];
          obj['mastersDegree']['major'] = item['majorFieldOfStudy'];
          obj['highestDegree'] = item['highestDegree']; 
          obj['highestDegreeDetails'] = this.formatHighDegree(this.petitionDetails['highestDegreeList'],item['highestDegree']);

          this.lcaInfo['educations'].push(obj)
        })
        
      }
    },
    formatHighDegree(list,item){
      if (item != null && _.get(list  ,'length')  > 0) {
        var _t = _.find(list, function (aitem) {

          return aitem.id == item
        })
        if(_t){
          return _t
        }             
	    }
    },
    manageEducations(data=null){
      
      this.educationsList = _.cloneDeep(this.masterEducationsList);
      let allUsedEducations =[]
       _.forEach(this.lcaInfo['educations'] ,(edu)=>{
        edu.highestDegree = this.checkProperty(edu ,'highestDegreeDetails','id');
        allUsedEducations.push(this.checkProperty(edu ,'highestDegreeDetails','id'));

      });
     // edu.highestDegree = checkProperty(edu ,'highestDegreeDetails','id') 
     // alert(JSON.stringify(allUsedEducations))
      // if(allUsedEducations && this.checkProperty(allUsedEducations ,'length') >0){
      //   this.educationsList = _.filter(this.masterEducationsList ,(edu)=>{
      //       return allUsedEducations.indexOf(edu.id)<=-1;
      //   });

      // }
      
    },
    addEducation(){
      this.manageEducations();
      let item = {
              "mastersDegree": { "schoolName": "", "major": "" },
              "highestDegree": null,
              "highestDegreeDetails": null
          }
      // educations:[

          // {
          //     "mastersDegree": { "schoolName": "", "major": "" },
          //     "highestDegree": null,
          //     "highestDegreeDetails": { "id": 3, "name": ""   }
          // }

      //     ]

      this.lcaInfo['educations'].push(item);
    },
    removeEducation(index){
      this.lcaInfo['educations'].splice(index, 1);
      this.manageEducations();

   },

    addJobDuty(){
      this.lcaInfo['multiJobDuties'].push({
        content:'',
      });

    },
    removeJobDuty(index){
      this.lcaInfo['multiJobDuties'].splice(index, 1);


   },

    updatedPetitionerDetails() {
      if (this.checkProperty(this.petitionerDetails, 'name')) {
        _.forEach(this.lcaInfo['layerInfo'], (item) => {
          if (this.checkProperty(item, 'layerType') == "Employer/Petitioner") {
            item.employerName = _.cloneDeep(this.checkProperty(this.petitionerDetails, 'name'));
          }
        })
        if (this.useEmployeeAdress) {
          if (this.getTenantTypeId == 2) {
            this.updateEmployeAddress();
          } else {
            this.getCompanyDetails()
          }

        }
      }
    },
    getPeritioners(searchString = '') {
      //petitioner_list_for_tenant_users
      let item = {
        page: 1,
        perpage: 10000000,
        category: "petitioner_list_for_tenant_users",
        matcher: {
          "searchString": searchString,

        },
        "sorting": {
          "path": "name",
          "order": 1
        }

      };
      if ([51].indexOf(this.getUserRoleId) > -1) {
        item['category'] = "petitioner_list_for_beneficaries"
      }
      this.$store.dispatch("getMasterData", item).then(response => {
        this.petitionerList = response.list;
        if (this.checkProperty(this.getLcaDetails, '_id') && this.checkProperty(this.getLcaDetails, 'petitionerId') && searchString == '') {
          this.petitionerDetails = _.find(this.petitionerList, { "_id": this.getLcaDetails['petitionerId'] });
          //this.updatedPetitionerDetails();
        }
        if(!this.petitionerDetails && this.checkProperty(this.petitionerList,'length')>0 && this.callFromActionPopup && this.checkProperty(this.getPetitionDetails,'petitionerId')){
          this.petitionerDetails = _.find(this.petitionerList, { "_id": this.checkProperty(this.getPetitionDetails,'petitionerId') });
        }
      });
    },
    getGlobalConfigDetails() {
      let postData = {}
      //  this.configDetails =null
      let path = 'global-config/details'
      this.$store.dispatch("commonAction", { data: postData, path: path })
        .then((response) => {
          this.configDetails = response['config'];
          this.updateEndClient();
          this.updateEmployerPetitioner();
          this.prepopulateEducations()


        }).catch((err) => {
          this.updateEndClient();
          this.updateEmployerPetitioner();

        })


    },
    fillExtractedData( callFRomConform=false){
     let self = this;
      if(this.documentExtractedData && callFRomConform){

      let response = _.cloneDeep(this.documentExtractedData)
      let lcaDetails = _.cloneDeep(response);


          if (_.has(lcaDetails, 'lcaDocCaseNo')) {
            this.lcaInfo = Object.assign(this.lcaInfo, { "lcaDocCaseNo": lcaDetails['lcaDocCaseNo'] });
            this.lcaInfo['lcaDocCaseNo'] = lcaDetails['lcaDocCaseNo'];
          }

          //alert(JSON.stringify(lcaDetails));
          // if (_.has(lcaDetails, 'socDetails')) {
          //   this.lcaInfo.socDetails = lcaDetails['socDetails'];
          // }
          if (_.has(lcaDetails, "jobDetails")) {
            let jobDetails = lcaDetails['jobDetails'];

            if (_.has(jobDetails, 'workAddresses')) {
              let workAddress = jobDetails['workAddresses']
              this.lcaInfo['workAddresses'] = []
              let address = { line1: "", line2: "", countryId: '', selectedCountry: null, "countryDetails": null, stateId: '', "stateDetails": null, stateDetails: null, selectedState: null, locationId: '', "locationDetails": null, selectedCity: null, zipcode: '', 'aptType': '', "workLocation": '' };
              _.forEach(workAddress, (item) => {
                _.forEach(item, (adval, adkey) => {
                  address[adkey] = adval;
                })
                this.lcaInfo['workAddresses'].push(address);
              })
              //alert(JSON.stringify(this.lcaInfo['workAddress']))


            }
            // if (_.has(jobDetails, 'employerName')) {
            //   this.lcaInfo['clientName']=jobDetails['employerName']
            // }

          }



          if (_.has(lcaDetails, 'caseStatus')) {
            let caseStatus = lcaDetails['caseStatus'];
            if (caseStatus == 'In Process') {
              caseStatus = 'Filed'
            }
            let lcastatusSelected = _.find(this.lcastatuses, { 'name': caseStatus });
            if (lcastatusSelected) {
              this.lcastatusSelected = lcastatusSelected;
              this.selectLcaStatus(lcastatusSelected);
              this.selectedStatusFromFile = true;
            }
            ////{{ lcastatusSelected }} 

          }
          //empEndDate empStartDate
          if (_.has(response, 'socDetails') && response['socDetails']) {
            if (JSON.stringify(response['socDetails']) != JSON.stringify({})) {
              this.lcaInfo['socDetails'] = response['socDetails'];
            }else{
              this.lcaInfo.socDetails = null;
            }
            // else {
            //   if (this.checkProperty(response, 'jobDetails', 'socCodeName')) {
            //     // alert(JSON.stringify(_.find(this.masterSocList, { 'name': this.checkProperty(response, 'jobDetails', 'socCodeName') })))
            //     if (_.find(this.masterSocList, { 'name': this.checkProperty(response, 'jobDetails', 'socCodeName') })) {
            //       this.lcaDetails.socDetails = _.find(this.masterSocList, { 'name': this.checkProperty(response, 'jobDetails', 'socCodeName') });
            //     }
            //   }
            // }

          }

          if (_.has(lcaDetails, 'certifiedDate') && lcaDetails['certifiedDate']) {
            this.lcaStatusDate = moment(lcaDetails['certifiedDate']).format("YYYY-MM-DD");
            Object.assign(this.lcaInfo, { "certifiedDate": this.lcaStatusDate });
          }
          if (_.has(lcaDetails, 'filedDate') && lcaDetails['filedDate']) {
            this.lcaStatusDate = moment(lcaDetails['filedDate']).format("YYYY-MM-DD");
            Object.assign(this.lcaInfo, { "filedDate": this.lcaStatusDate });
          }

          _.forEach(this.lcaInfo, (val, key) => {
            //  alert(key)
            //  if (_.has(lcaDetails, key) && ["subTypeName", "typeName", "petitionCaseNo"].indexOf(key) <= -1) {
            if (_.has(lcaDetails, key)) {
              if (key == "layerInfo") {

                let layerInfo = _.cloneDeep(lcaDetails['layerInfo'])

                if (this.checkProperty(lcaDetails, 'layerInfo', 'length') > 0) {

                  if (this.checkProperty(lcaDetails, 'noOfLayersBetweenClient') <= 0) {

                  } else {
                    if (this.checkProperty(lcaDetails, 'layerInfo', 'length') > this.checkProperty(lcaDetails, 'noOfLayersBetweenClient')) {

                      let lastIndex = parseInt((layerInfo.length) - 1);

                      let finalLayerInfo = [];
                      let finalBetweenClients = [];
                      _.forEach(layerInfo, (item, index) => {
                        if (this.checkProperty(item, 'layerType') == "Employer/Petitioner" || this.checkProperty(item, 'layerType') == "End-client") {
                          finalLayerInfo.push(item);
                        } else {

                          if (['Mid-Vendor', 'Prime-Vendor', 'Implementation Partner'].indexOf(this.checkProperty(item, 'layerType')) > -1) {
                            finalBetweenClients.push(item);
                          }




                        }


                      });

                      // this.lcaInfo['layerInfo'] = _.cloneDeep(finalLayerInfo);
                      this.lcaInfo['betweenClients'] = _.cloneDeep(finalBetweenClients);
                      let lcaInfo = this.lcaInfo;

                      this.lcaInfo = _.cloneDeep(lcaInfo);




                    }


                  }

                }


              } else {

                // if (key == 'certifiedDate' && lcaDetails[key]) {

                //   this.lcaStatusDate = moment(lcaDetails[key]).format("YYYY-MM-DD");
                //   Object.assign(this.lcaInfo, { "certifiedDate": this.lcaStatusDate });
                // }
                // if (key == 'filedDate' && lcaDetails[key]) {
                //   this.lcaStatusDate = moment(lcaDetails[key]).format("YYYY-MM-DD");
                //   Object.assign(this.lcaInfo, { "filedDate": this.lcaStatusDate });
                // }


                if (key == 'empStartDate' || key == 'empEndDate' && lcaDetails[key]) {
                  //updateEmpEndDate($event)"   wrapclass="md:w-1/2" v-model="lcaInfo.empStartDate" 

                  this.lcaInfo[key] = lcaDetails[key];
                  if (key == 'empStartDate') {
                    this.lcaInfo['empStartDate'] = moment(lcaDetails['empStartDate']).format("YYYY-MM-DD");
                    this.updateEmpEndDate(this.lcaInfo['empStartDate']);


                  } else if (key == 'empEndDate') {

                    this.lcaInfo['empEndDate'] = moment(lcaDetails['empEndDate']).format("YYYY-MM-DD");

                  }

                } else if (key == 'highestDegreeDetails') {
                  // lcaInfo.highestDegreeDetails education_types
                  this.lcaInfo['highestDegreeDetails'] = lcaDetails['highestDegreeDetails'];
                } else if (key == 'mastersDegree') {
                  this.lcaInfo['mastersDegree'] = lcaDetails['mastersDegree'];
                } else if (key == 'socDetails'||key == 'certifiedDate'||key == 'filedDate') {
                  
                }
                else {
                  this.lcaInfo[key] = lcaDetails[key];
                }



              }


              // if (key == 'workAddress') {
              //   let address = { line1: "", line2: "", countryId: '', selectedCountry: null, "countryDetails": null, stateId: '', "stateDetails": null, stateDetails: null, selectedState: null, locationId: '', "locationDetails": null, selectedCity: null, zipcode: '', 'aptType': '', "workLocation": false };
              //   _.forEach(lcaDetails['workAddresses'], (adval, adkey) => {

              //     address[adkey] = adval;
              //   })
              //   this.lcaInfo['workAddress'] = address;
              // }
              //secondaryWorkAddress
              if (key == 'secondaryWorkAddress') {
                let address = { line1: "", line2: "", countryId: '', selectedCountry: null, "countryDetails": null, stateId: '', "stateDetails": null, selectedState: null, stateDetails: null, locationId: '', "locationDetails": null, selectedCity: null, zipcode: '', 'aptType': '', "workLocation": false };
                _.forEach(lcaDetails[key], (adval, adkey) => {

                  address[adkey] = adval;
                })
                this.lcaInfo['secondaryWorkAddress'] = address;
              }
              //betweenClients  layerInfo


            }


          })

        }else{
          self.document = [];
        }

       



    setTimeout(() => {
      self.approveConformpopUp = false;
      self.fileUploaded = true;
      setTimeout(() => { self.$vs.loading.close(); }, 100)
      self.preFilling = false;
      self.updateEndClient();
      self.updateEmployerPetitioner();
    }, 200)

    },
    extractFileData(fileUrl = '') {
      let self = this;
      this.selectedStatusFromFile = false;
      this.preFilling = false;
      this.approveConformpopUp = false;
      this.documentExtractedMsg ='' ;
      this.documentExtractedData =null;
      let data = {
        "lcaDocument": ''
      };
      if (fileUrl != '') {
        this.fileUploaded = false;
        this.preFilling = true;
        data['lcaDocument'] = fileUrl;
        let path = "/petition/extract-lca-data-from-pdf"
        this.$store.dispatch('commonCaseAction', { "data": data, 'path': path })
          .then((response) => {
            this.documentExtractedData = _.cloneDeep(response);
            if(this.checkProperty(response ,'code') =='LCA_DOC_CASE_NO_ALREADY_USED' && this.checkProperty(response ,'message')){
              this.approveConformpopUp = true;
              this.documentExtractedMsg =this.checkProperty(response ,'message') ;
              
            }else{
              this.fillExtractedData(true);
            }
          })
          .catch((error) => {

            if (_.get(error, 'result.error.code') == 'LCA_DOC_CASE_NO_ALREADY_USED') {
              self.showToster({ message: self.checkProperty(error, "message"), isError: true });
              self.document = [];
            }
            self.preFilling = false;
            self.fileUploaded = true;
            self.$vs.loading.close();
          })
      } else {
        this.fileUploaded = true;
      }

    },
    getCompanyDetails() {

      if (this.lcaInfo.internalEmployee) {
        let path = '/company/details';
        let data = { 'companyId': null };

        if (!this.isFromLCAList && _.has(this.petitionDetails, 'companyDetails', '_id')) {
          data['companyId'] = this.petitionDetails['companyDetails']['_id'];
          this.$store.dispatch('commonAction', { "data": data, 'path': path })
            .then((response) => {
              this.companyDetails = response;
              if (this.useEmployeeAdress) {
                this.updateEmployeAddress()
              }
            })
            .catch((error) => {

            })
        }
        else if (this.isFromLCAList&&!this.checkProperty(this.getLcaDetails, '_id') && [50].indexOf(this.getUserRoleId) > -1) {
          data['companyId'] = this.getUserData['companyDetails']['_id'];
          this.$store.dispatch('commonAction', { "data": data, 'path': path })
            .then((response) => {
              this.companyDetails = response;
              if (this.useEmployeeAdress) {
                this.updateEmployeAddress()
              }
            })
            .catch((error) => {
            })
        } else if (this.isFromLCAList&&!this.checkProperty(this.getLcaDetails, '_id') && [50, 51].indexOf(this.getUserRoleId) <= -1 && this.checkProperty(this.petitionerDetails, 'companyId')) {
          data['companyId'] = this.petitionerDetails['companyId'];
          this.$store.dispatch('commonAction', { "data": data, 'path': path })
            .then((response) => {
              this.companyDetails = response;
              if (this.useEmployeeAdress) {
                this.updateEmployeAddress()
              }
            })
            .catch((error) => {
            })
        } else if (this.isFromLCAList&&this.checkProperty(this.getLcaDetails, '_id')&& this.checkProperty(this.petitionerDetails, 'companyId')) {
          data['companyId'] = this.petitionerDetails['companyId'];
          this.$store.dispatch('commonAction', { "data": data, 'path': path })
            .then((response) => {
              this.companyDetails = response;
              if (this.useEmployeeAdress) {
                this.updateEmployeAddress()
              }
            })
            .catch((error) => {
            })
        }

      }
      else {
        this.useEmployeeAdress = false
        if (this.checkProperty(this.petitionerDetails, 'name')) {
        _.forEach(this.lcaInfo['layerInfo'], (item) => {
          if (this.checkProperty(item, 'layerType') == "Employer/Petitioner") {
            item.employerName = _.cloneDeep(this.checkProperty(this.petitionerDetails, 'name'));
          }
        })
      }else if (this.checkProperty(this.getLcaDetails, '_id') && [50].indexOf(this.getUserRoleId) > -1) {
         _.forEach(this.lcaInfo['layerInfo'], (item) => {
           if (this.checkProperty(item, 'layerType') == "Employer/Petitioner") {
             item.employerName = this.checkProperty(this.getUserData, 'companyDetails', "name");
           }

         })
       }

      // if (!this.isFromLCAList && _.has(this.petitionDetails, 'companyDetails', '_id')) {
      //   let path = '/company/details';
      //   let data = { 'companyId': null };
      //   data['companyId'] = this.petitionDetails['companyDetails']['_id'];
      //   this.$store.dispatch('commonAction', { "data": data, 'path': path })
      //     .then((response) => {
      //       this.companyDetails = response;
      //     })
      //     .catch((error) => {

      //     })
      // } else if (this.isFromLCAList) {
      //   if (this.getUserRoleId == 50 && this.checkProperty(this.getUserData, 'companyDetails', '_id')) {
      //     let path = '/company/details';
      //     let data = { 'companyId': null };
      //     data['companyId'] = this.getUserData['companyDetails']['_id'];
      //     this.$store.dispatch('commonAction', { "data": data, 'path': path })
      //       .then((response) => {
      //         this.companyDetails = response;
      //       })
      //       .catch((error) => {
      //       })
      //   }
      // }
      }
    },
  
    updateEmployeAddress() {
      //
      if (this.useEmployeeAdress) {
        let userData = this.getUserData;
        if (this.getTenantTypeId == 2) {
          if (_.has(userData, 'tenantDetails', 'address')) {
            // this.lcaInfo['workAddresses'] = [];
            // this.lcaInfo['workAddresses'] = [];
            //   this.lcaInfo['workAddresses'] = [];

            let newAddress = {
              "companyName": "",
              "workLocation": '',
              line1: "",
              line2: "",
              zipcode: "",
              countryId: "231",
              stateId: "",
              locationId: "",
              "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
              stateDetails: null,
              locationDetails: null,
              aptType: ''
            }


            newAddress = _.cloneDeep(userData['tenantDetails']['address']);
            newAddress['companyName'] = '';
            newAddress['workLocation'] = '';
            if (this.lcaInfo['workAddresses'].length <= 1) {
              this.lcaInfo['workAddresses'] = [];
              this.lcaInfo['workAddresses'] = [];
              this.lcaInfo['workAddresses'].push(newAddress);
            } else {
              //this.lcaInfo['workAddresses'].unshift(newAddress);
              let addressList = _.cloneDeep(this.lcaInfo['workAddresses'])
              this.lcaInfo['workAddresses'] = [newAddress].concat(addressList)
            }

          }
        }
        else {
          if (_.has(this.companyDetails, 'address')) {
            let petAddress = _.cloneDeep(this.companyDetails['address']);
            let petWorkLocation = '';
            if(this.lcaInfo['workAddresses'] && this.checkProperty(this.lcaInfo['workAddresses'],'length')>0){
              let tempAddress = this.lcaInfo['workAddresses'][0];
              if(_.has(tempAddress,'workLocation')){
                petWorkLocation = tempAddress['workLocation']
              }
            }
            petAddress['companyName'] = this.checkProperty(this.companyDetails, 'name');
            petAddress['workLocation'] = petWorkLocation;

            if (this.lcaInfo['workAddresses'].length <= 1) {
              this.lcaInfo['workAddresses'] = [];
              this.lcaInfo['workAddresses'] = [];
              this.lcaInfo['workAddresses'].push(petAddress);
            } else {
              let addressList = _.cloneDeep(this.lcaInfo['workAddresses'])
             
              if(addressList && this.checkProperty(addressList,'length')>0){
                addressList.splice(0, 1); 
              }
              this.lcaInfo['workAddresses'] = [petAddress].concat(addressList)
            }

          }

        }



        this.$validator.reset();
      }
    },
    CheckTotalEmpl(){
    
      if (this.lcaInfo.noOfEmployeesOnH1bOrL1) {
        if(parseInt(this.lcaInfo.noOfEmployeeOnYourPayroll) < parseInt(this.lcaInfo.noOfEmployeesOnH1bOrL1)){
          this.lcaInfo.noOfEmployeesOnH1bOrL1 = null;
         }
      }
    },
    employeeCheck() {
      // if(this.lcaInfo.noOfEmployeesOnH1bOrL1 > this.lcaInfo.noOfEmployeeOnYourPayroll){
      //   this.lcaInfo.noOfEmployeeOnYourPayroll = null;
      //   this.lcaInfo.noOfEmployeesOnH1bOrL1 = null;
      //   // this.maxEmpError =
      // }
      if (parseInt(this.lcaInfo.noOfEmployeesOnH1bOrL1) >= parseInt(this.lcaInfo.noOfEmployeeOnYourPayroll)) {

        this.lcaInfo.noOfEmployeesOnH1bOrL1 = null;
        this.maxEmpError = 'Number of Employees on H1B or L1 must be Less than total Employees';
      }
      
      else if (parseInt(this.lcaInfo.noOfEmployeesOnH1bOrL1) < parseInt(this.lcaInfo.noOfEmployeeOnYourPayroll)) {
        this.maxEmpError = null;
      }


    },
    updateEmpEndDate(val) {
      if (val) {
        let startDate = moment(val);
        if (this.lcaInfo.empEndDate) {
          let endDate = moment(this.lcaInfo.empEndDate)
          if (startDate.isAfter(endDate, 'day')) {
            this.lcaInfo.empEndDate = null
          }
        }
      }
    },
    setWorkLocation(indexx) {
      setTimeout(() => {
        _.map(this.lcaInfo['workAddresses'], (item, ind) => {
          if (ind != indexx) {
            item.workLocation = '';
          }
        })
      });

    },
    addAddress() {

      let newAddress = {
        "companyName": "",
        "workLocation": '',
        line1: "",
        line2: "",
        zipcode: "",
        countryId: "231",
        stateId: "",
        locationId: "",
        "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
        stateDetails: null,
        locationDetails: null,
        aptType: ''
      }
      this.lcaInfo['workAddresses'].push(newAddress);
      this.$validator.reset();



    },
    removeAddress(index) {
      this.lcaInfo['workAddresses'].splice(index, 1);

    },
    updatesecondaryWorLocation(category = 'secondarlocation') {

      if (category == 'secondarlocation') {
        if (this.lcaInfo.secondarlocation == 0) {
          this.lcaInfo.secondaryWorkAddressCompanyName = ''
        } else {

        }

      }

    },
    addVendor(betweenItem) {
      this.loadBetweens = true;
      if (this.checkProperty(this.lcaInfo, 'betweenClients', 'length') < 3) {
        // 
        let item = {
          "layerType": "",
          "employerName": ""
        }

        this.lcaInfo['betweenClients'].push(item);
        //let betweenClients = _.cloneDeep(this.lcaInfo['betweenClients']);
        //  betweenClients.push(item);
        // this.lcaInfo['betweenClients'] = betweenClients;
        // this.lcaInfo = _.cloneDeep(this.lcaInfo);
      }


      this.updateAvailableVendors();
      this.updateEndClient();
      this.updateEmployerPetitioner();
      this.lcaInfo['noOfLayersBetweenClient'] = this.checkProperty(this.lcaInfo, 'betweenClients', 'length') > 0 ? this.checkProperty(this.lcaInfo, 'betweenClients', 'length') : 0;
      setTimeout(() => {
        this.loadBetweens = true;

      });


    },
    removeVendor(ind) {
      this.loadBetweens = true;
      this.lcaInfo['betweenClients'].splice(ind, 1);
      this.lcaInfo['betweenClients'] = _.cloneDeep(this.lcaInfo['betweenClients']);


      this.updateAvailableVendors();
      this.updateEndClient();
      this.updateEmployerPetitioner();
      this.lcaInfo['noOfLayersBetweenClient'] = this.checkProperty(this.lcaInfo, 'betweenClients', 'length') > 0 ? this.checkProperty(this.lcaInfo, 'betweenClients', 'length') : 0;
      setTimeout(() => {
        this.loadBetweens = true;

      });

    },
    updateEmployerPetitioner() {
      _.forEach(this.lcaInfo['layerInfo'], (item) => {

        //lcaInfo.noOfEmployeeOnYourPayroll
        //lcaInfo.noOfEmployeesOnH1bOrL1

        if (this.checkProperty(item, 'layerType') == "Employer/Petitioner") {
          if (this.getTenantTypeId == 2) {
            if (this.checkProperty(this.getUserData, 'tenantDetails', 'name')) {
              item['employerName'] = this.checkProperty(this.getUserData, 'tenantDetails', 'name');
            } else {
              item['employerName'] = this.checkProperty(this.getUserData, 'tenantDetails', 'adminName');
            }
          } else {
            if (this.checkProperty(this.getPetitionDetails, 'petitionerDetails', 'name')) {
              item['employerName'] = this.checkProperty(this.getPetitionDetails, 'petitionerDetails', 'name');
            } else {
              if (!this.checkProperty(this.getLcaDetails, '_id') && [50].indexOf(this.getUserRoleId) > -1) {
                _.forEach(this.lcaInfo['layerInfo'], (item) => {
                  if (this.checkProperty(item, 'layerType') == "Employer/Petitioner") {
                    item.employerName = this.checkProperty(this.getUserData, 'companyDetails', "name");
                  }

                })
              }
            }
          }

        }
        if (!this.checkProperty(this.lcaInfo, 'noOfEmployeeOnYourPayroll') && this.checkProperty(this.getPetitionDetails, 'petitionerDetails', 'totalFullTimeEmployees')) {
          this.lcaInfo.noOfEmployeeOnYourPayroll = this.checkProperty(this.getPetitionDetails, 'petitionerDetails', 'totalFullTimeEmployees');

        }
        if (!this.checkProperty(this.lcaInfo, 'noOfEmployeesOnH1bOrL1')) {

        }

      })



    },
    updateEndClient() {
      _.forEach(this.lcaInfo['layerInfo'], (item) => {

        if (this.checkProperty(item, 'layerType') == "End-client") {
          item['employerName'] = this.checkProperty(this.lcaInfo, 'clientName');
        }

      })
      this.lcaInfo['layerInfo'] = _.cloneDeep(this.lcaInfo['layerInfo']);
      this.updateEmployerPetitioner();
    },
    updateAvailableVendors(item) {
      this.availableVendors = ['Mid-Vendor', 'Prime-Vendor', 'Implementation Partner'];
      this.availableVendors = _.filter(this.availableVendors, (vendor) => {
        let findObj = _.find(this.lcaInfo['betweenClients'], { "layerType": vendor })
        return !findObj;
      })






    },
    changedNoOfLayersBetweenClient(item) {

      if (this.checkProperty(this.lcaInfo, 'noOfLayersBetweenClient') <= 0) {
        this.lcaInfo['betweenClients'] = [];
      } else if (this.checkProperty(this.lcaInfo, 'betweenClients', 'length') < this.checkProperty(this.lcaInfo, 'noOfLayersBetweenClient')) {

        let availablesoace = parseInt((this.lcaInfo['noOfLayersBetweenClient']) - (this.lcaInfo['betweenClients'].length));

        for (let i = 0; i < availablesoace; i++) {

          let item = {
            "layerType": "",
            "employerName": ""
          };
          this.lcaInfo['betweenClients'].push(item);

        }

      } else {

        let noOfLayersBetweenClient = this.lcaInfo['noOfLayersBetweenClient'];
        let filterItems = [];
        _.forEach(this.lcaInfo['betweenClients'], (item, index) => {
          if (index + 1 <= noOfLayersBetweenClient) {
            filterItems.push(item);
          }
          this.lcaInfo['betweenClients'] = _.cloneDeep(filterItems);
          this.lcaInfo = _.cloneDeep(this.lcaInfo);

        })


      }

      //  layerInfo:[
      //   {
      //     "layerType": "",
      //     "employerName": ""
      //   }
      // ],
      // betweenClients:[],

      this.updateAvailableVendors();





    },

    goBack() {

      if (this.checkProperty(this.getLcaDetails, '_id')) {

        this.$emit('editLca', false)
        this.$emit("updatepetition", 'LCA');
        if (this.isFromLCAList) {
          this.$emit("lcaRequestCancel");
        }
      } else {
        this.$emit("updatepetition", 'Case Details');
        if (this.isFromLCAList) {
          this.$emit("lcaRequestCancel");
        }
      }

    },
    updateLCaInfo(callFromRequest = false) {
      let callfromReust = callFromRequest;
      if((this.checkProperty(this.getLcaDetails, 'multiEduDetailsForLCA') == true) || (this.checkProperty(this.configDetails, 'multiEduDetailsForLCA') == true && !this.checkProperty(this.getLcaDetails, '_id'))){
        //lcaInfo['educations']
        //lcaInfo.highestDegreeDetails
        let mastersDegree = null;
        let bachelorsDegree = null;// _.find(this.lcaInfo['educations'] , { "highestDegreeDetails.id":4});
        _.forEach(this.lcaInfo['educations'] ,(edu)=>{
          if(edu && this.checkProperty(edu , 'highestDegreeDetails' ,'id')==6 ){
            
            mastersDegree = edu
          }
          if(edu && this.checkProperty(edu , 'highestDegreeDetails' ,'id')==4 ){
            
            bachelorsDegree = edu
          }

        });
        //alert(JSON.stringify(mastersDegree));
       
    
      }
      let self = this;
      this.updateEndClient();
      this.updateEmployerPetitioner();
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updatingLca = true
          if (this.checkProperty(this.getPetitionDetails, '_id')) {
            Object.assign(this.lcaInfo, {
              petitionId: this.getPetitionDetails._id,
              petitionerId: this.getPetitionDetails.petitionerId,
              userId: this.getPetitionDetails.userId,
              today: moment().format("YYYY-MM-DD"),
              petitionCaseNo: this.getPetitionDetails.caseNo,
              beneficiaryName: this.getPetitionDetails.beneficiaryDetails.name,
              petitionerName: this.getPetitionDetails.createdByDetails.name,

              lcastatusSelected: this.lcastatusSelected,
              documents: {
                filed: [],
                certified: [],
                others:[]
              },
              type: this.checkProperty(this.getPetitionDetails, 'typeDetails', 'name'),
              subType: this.checkProperty(this.getPetitionDetails, 'subTypeDetails', 'name'),
              typeName: this.checkProperty(this.getPetitionDetails, 'typeDetails', 'name'),
              subTypeName: this.checkProperty(this.getPetitionDetails, 'subTypeDetails', 'name'),
              action: this.uploadlca == 'true' ? "LCA_SUBMIT" : "LCA_REQUEST",

            });
          } else {
            Object.assign(this.lcaInfo, {
              // petitionId: this.getPetitionDetails._id,
              // petitionerId: this.getPetitionDetails.petitionerId,
              //  userId: this.getPetitionDetails.userId,
              today: moment().format("YYYY-MM-DD"),
              //  petitionCaseNo: this.getPetitionDetails.caseNo,
              //  beneficiaryName: this.getPetitionDetails.beneficiaryDetails.name,
              //  petitionerName: this.getPetitionDetails.createdByDetails.name,

              lcastatusSelected: this.lcastatusSelected,
              documents: {
                filed: [],
                certified: [],
                others:[]
              },
              //  type:this.checkProperty(this.getPetitionDetails,'typeDetails','name'),
              //  subType:this.checkProperty(this.getPetitionDetails,'subTypeDetails','name'),
              //  typeName:this.checkProperty(this.getPetitionDetails,'typeDetails','name'),
              //  subTypeName:this.checkProperty(this.getPetitionDetails,'subTypeDetails','name'),
              action: this.uploadlca == 'true' ? "LCA_SUBMIT" : "LCA_REQUEST",
            });
            Vue.delete(this.lcaInfo, 'petitionId');

            // if ([50].indexOf(this.getUserRoleId) > -1 && this.checkProperty(this.getUserData, 'userId')) {
            //   this.lcaInfo['petitionerId'] = this.checkProperty(this.getUserData, 'userId')
            //   if (this.checkProperty(this.getUserData, 'name')) {
            //     this.lcaInfo['petitionerName'] = this.checkProperty(this.getUserData, 'name')
            //   }
            // }
            // if (this.getTenantTypeId == 2 && this.checkProperty(this.getUserData, 'tenantDetails', 'userId')) {
            //   this.lcaInfo['petitionerId'] = this.checkProperty(this.getUserData, 'tenantDetails', 'userId')
            //   if (this.checkProperty(this.getUserData, 'tenantDetails', 'name')) {
            //     this.lcaInfo['petitionerId'] = this.checkProperty(this.getUserData, 'tenantDetails', 'name');
            //   } else {
            //     this.lcaInfo['petitionerId'] = this.checkProperty(this.getUserData, 'tenantDetails', 'adminName');
            //   }
            // }
          }

          if (this.lcaInfo.statusId == 2) {

            Object.assign(this.lcaInfo['documents'], { 'filed': this.document });


            let lcaStatusDate = moment(this.lcaStatusDate).format("YYYY-MM-DD");
            Object.assign(this.lcaInfo, { "filedDate": lcaStatusDate });


          } else if (this.lcaInfo.statusId == 3) {

            Object.assign(this.lcaInfo['documents'], { 'certified': this.document })
            let lcaStatusDate = moment(this.lcaStatusDate).format("YYYY-MM-DD");
            Object.assign(this.lcaInfo, { "certifiedDate": lcaStatusDate });
          }
          Object.assign(this.lcaInfo['documents'], { 'others': this.others });
          this.lcaInfo['noOfLayersBetweenClient'] = this.checkProperty(this.lcaInfo['betweenClients'], length);
          let postData = _.cloneDeep(this.lcaInfo);

          if (!this.checkProperty(this.lcaInfo, 'internalEmployee')) {

            postData['empWorkForAnyThirdParty'] = true;
            //betweenClients
            if (this.checkProperty(postData, 'betweenClients', 'length') > 0 && this.checkProperty(postData, 'layerInfo', 'length') > 0) {

              let layerInfo = _.cloneDeep(postData['layerInfo']);
              let finalLayerInfo = [];
              finalLayerInfo.push(layerInfo[0]);
              _.forEach(postData['betweenClients'], (item) => {
                finalLayerInfo.push(item);

              })
              if (this.checkProperty(layerInfo, 'length') > 1) {
                finalLayerInfo.push(layerInfo[1]);
              }
              postData = Object.assign(postData, { 'layerInfo': [] });
              _.forEach(finalLayerInfo, (client) => {
                if (["Employer/Petitioner", 'End-client'].indexOf(this.checkProperty(client, 'layerType')) > -1 || ['Mid-Vendor', 'Prime-Vendor', 'Implementation Partner'].indexOf(this.checkProperty(client, 'layerType')) > -1) {
                  postData['layerInfo'].push(client);
                }

              })






            }
          } else {
            postData['layerInfo'] = [];
            this.lcaInfo['noOfLayersBetweenClient'] = 0;
            postData['empWorkForAnyThirdParty'] = false;

          }
          if (postData.secondarlocation <= 0) {

            postData['secondaryWorkAddress'] = {
              line1: "",
              line2: "",
              zipcode: "",
              countryId: 231,
              countryDetails: { "_id": "61408c9ed01ea1248cdcf6b7", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
              stateId: null,
              locationId: null,
              stateDetails: null,
              locationDetails: null,
              aptType: '',
              workLocation: null
            }
          }
          postData['highestDegree'] = this.checkProperty(postData, 'highestDegreeDetails', 'id')

          if (!this.checkProperty(this.lcaInfo, 'fullTimePosition') && this.checkProperty(this.lcaInfo, 'hoursPerWeek') > 0) {

            postData['hoursPerWeek'] = parseInt(this.lcaInfo['hoursPerWeek'])

          }
          //alert(JSON.stringify(postData)); lcaInfo.socDetails" desiredSOCCode


          if ([2, 3].indexOf(this.lcaInfo.statusId) > -1) {

            postData['desiredSOCCode'] = this.checkProperty(this.lcaInfo, 'socDetails', 'id');
          } else {
            postData['preferredSOCCode'] = this.checkProperty(this.lcaInfo, 'preferredSocDetails', 'id');


          }
          //"innerAction": "UPDATE_BASIC_INFO",

          if (this.checkProperty(this.getLcaDetails, '_id')) {
            postData = Object.assign(postData, { "innerAction": "UPDATE_BASIC_INFO", "lcaId": '', "updateType": "basic-info" })
            postData['lcaId'] = this.checkProperty(this.getLcaDetails, '_id');
          }
          postData['submittedWithLink'] = false;
          if (this.checkProperty(this.$route, 'name') == 'fill-lca-anonymous-user') {
            postData['submittedWithLink'] = true;
          }
          if (this.checkProperty(this.getLcaDetails, 'statusId') ==99 && !this.checkProperty(postData ,'statusId')) {
            postData['statusId'] =1;

          }
          postData = Object.assign(postData, { "consentChecked": this.consentChecked, "termsAndConditionsChecked": this.termsAndConditionsChecked });
          this.$vs.loading();
          this.submtingForm = true;
          let path = "/lca/update"
          this.$store.dispatch("commonAction", { data: postData, path: path })

            .then((response) => {
              this.updatingLca = false
              if (this.checkIsLcaExcuitive || this.isFromLCAList) {
                this.showToster({ message: response.message, isError: false });
                this.$emit("updatepetition", 'LCA');
              }

              setTimeout(() => {
                this.$store.dispatch("setPetitionTab", '').then(() => {
                  this.$emit('editLca', false)
                  this.$emit("updatepetition", 'LCA');
                  this.submitedlca = false;
                }).catch(() => {
                  this.$emit("updatepetition", 'LCA');
                  this.submitedlca = false;

                })
                this.$vs.loading.close();

              }, 10);


            })
            .catch((error) => {
              this.$vs.loading.close();
              this.updatingLca = false
              this.submtingForm = false;
              this.showToster({ message: error, isError: true });

            });



        } else {

          const $ = JQuery;
          $('html, body').animate({
            scrollTop: ($('.text-danger').first().offset().top)
          }, 500);

          // const firstField = Object.keys(this.errors.collect())[0];
          //   const ele = $("[name=" + firstField + "]").parents(".vx-col");
          //  $("html, body").animate({ scrollTop: ele.offset().top }, 2000);
        }
      })






    },
    processData() {
      if (this.checkProperty(this.getLcaDetails, '_id')) {
        let getLcaDetails = _.cloneDeep(this.getLcaDetails);
        if(this.checkProperty(getLcaDetails,'documents','others') && this.checkProperty(getLcaDetails['documents'],'others','length')>0 ){
          this.others = _.cloneDeep(this.checkProperty(getLcaDetails,'documents','others'));
        }
        _.forEach(this.lcaInfo, (val, key) => {
          if (_.has(getLcaDetails, key)) {

            if (key == "layerInfo") {

              let layerInfo = _.cloneDeep(getLcaDetails['layerInfo'])

              if (this.checkProperty(getLcaDetails, 'layerInfo', 'length') > 0) {

                // if (this.checkProperty(getLcaDetails, 'noOfLayersBetweenClient') <= 0) {

                // } else {
                if (this.checkProperty(getLcaDetails, 'layerInfo', 'length') > 0) {

                  let lastIndex = parseInt((layerInfo.length) - 1);
                  let finalLayerInfo = [];
                  let finalBetweenClients = [];
                  _.forEach(layerInfo, (item, index) => {
                    if (this.checkProperty(item, 'layerType') == "Employer/Petitioner" || this.checkProperty(item, 'layerType') == "End-client") {
                      finalLayerInfo.push(item);
                    } else {

                      if (['Mid-Vendor', 'Prime-Vendor', 'Implementation Partner'].indexOf(this.checkProperty(item, 'layerType')) > -1) {
                        finalBetweenClients.push(item);
                      }




                    }


                  });



                  this.lcaInfo['layerInfo'] = [];
                  this.lcaInfo['betweenClients'] = [];
                  setTimeout(() => {
                    this.lcaInfo['layerInfo'] = _.cloneDeep(finalLayerInfo);
                    this.lcaInfo['betweenClients'] = _.cloneDeep(finalBetweenClients);
                    this.lcaInfo = _.cloneDeep(this.lcaInfo);
                  }, 100);



                  //  alert(JSON.stringify(this.lcaInfo))

                }


                //  }

              }


            } else {
              if(key  == 'preferredSocDetails'){
                let temp = getLcaDetails[key];
                if(_.has(temp,'designation') && this.checkProperty(temp,'designation')){
                  temp['name'] = temp['name'] + ' ('+temp['designation']+')';
                }
                this.lcaInfo[key] = temp;
              }else{
                this.lcaInfo[key] = getLcaDetails[key];
              }
              

            }


            // if (key == 'workAddress') {
            //   let address = { line1: "", line2: "", countryId: '', selectedCountry: null, "countryDetails": null, stateId: '', "stateDetails": null, stateDetails: null, selectedState: null, locationId: '', "locationDetails": null, selectedCity: null, zipcode: '', 'aptType': '', "workLocation": false };
            //   _.forEach(getLcaDetails[key], (adval, adkey) => {

            //     address[adkey] = adval;
            //   })
            //   this.lcaInfo['workAddress'] = address;
            // }
            if (key == 'workAddresses') {
              if(getLcaDetails[key]){
                this.lcaInfo['workAddresses'] = _.cloneDeep(getLcaDetails[key]);
              }
              
            }
            //secondaryWorkAddress
            if (key == 'secondaryWorkAddress') {
              let address = { line1: "", line2: "", countryId: '', selectedCountry: null, "countryDetails": null, stateId: '', "stateDetails": null, selectedState: null, stateDetails: null, locationId: '', "locationDetails": null, selectedCity: null, zipcode: '', 'aptType': '', "workLocation": false };
              _.forEach(getLcaDetails[key], (adval, adkey) => {

                address[adkey] = adval;
              })
              this.lcaInfo['secondaryWorkAddress'] = address;
            }
            //betweenClients  layerInfo


          }


        })

        // this.fullTimePositionChanged();
        if (this.checkProperty(this.lcaInfo, 'layerInfo', 'length') <= 0) {
          this.lcaInfo['layerInfo'] = [
            {
              "layerType": "Employer/Petitioner",
              "employerName": ""
            },
            {
              "layerType": "End-client",
              "employerName": ""
            }
          ];
          //this.lcaInfo = _.cloneDeep(this.lcaInfo);

        }
        this.updateAvailableVendors();
        this.updateEndClient();
        this.updateEmployerPetitioner();

        if (this.checkProperty(this.getLcaDetails, 'wageLevelDetails')) {
          this.selectedWage = _.cloneDeep(this.getLcaDetails['wageLevelDetails']);
          this.selectWage(this.selectedWage)


        }




        //this.fullTimePositionChanged()
      }
    },

    internalEmployeeChanged() {
      //alert(this.lcaInfo.internalEmployee)
      //useEmployeeAdress
      // this.getCompanyDetails();
      this.updateEndClient();
      this.updateEmployerPetitioner();



      setTimeout(() => {
        //this.lcaInfo['empWorkForAnyThirdParty'] =!this.lcaInfo.internalEmployee;
        this.lcaInfo['empWorkForAnyThirdParty'] = !this.useEmployeeAdress;
        if (this.useEmployeeAdress) {
          if (this.getTenantTypeId == 2) {
            this.updateEmployeAddress();
          } else {
            this.getCompanyDetails()
          }
          // this.updateEmployeAddress();
        }
        else {
          let addObj = {
              "companyName": "",
              "workLocation": '',
              line1: "",
              line2: "",
              zipcode: "",
              countryId: "231",
              stateId: "",
              locationId: "",
              "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
              stateDetails: null,
              locationDetails: null,
              aptType: ''
            }
            if(this.lcaInfo.workAddresses && this.checkProperty(this.lcaInfo.workAddresses,'length')>0){
              this.lcaInfo.workAddresses.splice(0, 1); 
              let addressList = _.cloneDeep(this.lcaInfo.workAddresses)
              this.lcaInfo['workAddresses'] = [addObj].concat(addressList)
            }
          // this.lcaInfo.workAddresses = [
          //   {
          //     "companyName": "",
          //     "workLocation": true,
          //     line1: "",
          //     line2: "",
          //     zipcode: "",
          //     countryId: "231",
          //     stateId: "",
          //     locationId: "",
          //     "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
          //     stateDetails: null,
          //     locationDetails: null,
          //     aptType: ''
          //   }

          // ]
        }



      }, 50);


    },
    secondaryAddressAsHome() {

      if (this.lcaInfo.secondaryWorkAddress.workLocation == 1) {
        this.lcaInfo.workAddress.workLocation = 0;
      }
    },
    primaryAddressAsHome() {

      if (this.lcaInfo.workAddress.workLocation == 1) {

        this.lcaInfo.secondaryWorkAddress.workLocation = 0;
      }
    },

    getMasterSocList() {

      let query = {};
      query["page"] = 1;
      query["perpage"] = 10000;
      query["matcher"] = {
        //"getInactiveListAlso": true
      };
      query["category"] = "soc_codes";
      query["sorting"] = this.sortKey;

      this.$store
        .dispatch("getMasterData", query)
        .then((response) => {
          this.masterSocList = response.list;


          //alert(this.perpage);
        })
        .catch(() => {
          this.masterSocList = [];

        });

    },

    fullTimePositionChanged() {
      //  if(this.lcaInfo.fullTimePosition){
      this.lcaInfo.hoursPerWeek = null;

      //   }

    },

    selectLcaStatus(item) {
      this.lcastatusSelected = item;
      if (_.has(this.lcastatusSelected, "id")) {
        this.lcaInfo = Object.assign(this.lcaInfo, {
          statusId: this.lcastatusSelected['id'],
          statusName: this.lcastatusSelected['name'],
          documents: { filed: [], certified: [],others:[] }


        });
        this.selectLcaStatusDate = this.checkProperty(this.lcastatusSelected, 'name') + ' Date'
        //selectLcaStatusDate
      }
      //this.$validator.reset();
    },
    reFreshPage(reshPage = false) {
      this.comments = '';
      if ((this.lcaSaveCompleted && this.lawFirmsubmitCompleted) || reshPage) {


        this.showCommentPopup = false;
        this.submtingForm = false;
        //this.submitedlca = true;

        setTimeout(() => {

          this.$store.dispatch("setPetitionTab", '').then(() => {
            this.$emit("updatepetition", 'LCA');
            this.submitedlca = false;

          }).catch(() => {
            this.$emit("updatepetition", 'LCA');
            this.submitedlca = false;

          })


        }, 10);


        this.$vs.loading.close();


        // document.addEventListener("click", this.reloadpage);

      }
    },

    saveOnlyLca() {

     

      
      this.ValidLcaForm = false;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updatingLca = true
          this.ValidLcaForm = true
          this.saveLCAInfo(true);

        } else {

          const $ = JQuery;

          //const firstField = Object.keys(this.errors.collect())[0];
          // const ele = $("[name=" + firstField + "]").parents(".vx-col");
          // $("html, body").animate({ scrollTop: ele.offset().top }, 2000);

          $('html, body').animate({
            scrollTop: ($('.text-danger').first().offset().top)
          }, 500);
        }

      })
    },

    valiDateLcaRequest() {

      this.ValidLcaForm = false;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.comments = '';
          if (this.checkProperty(this.getPetitionDetails, 'typeDetails', 'name') && this.checkProperty(this.getPetitionDetails, 'subTypeDetails', 'name')) {

            if ([50].indexOf(this.getUserRoleId) > -1) {
              this.comments = "Case is being submitted to " + this.getPetitionDetails.tenantDetails.name + " for further actions."

            } else {

              this.comments = "Case " + this.getPetitionDetails.typeDetails.name + ", " + this.getPetitionDetails.subTypeDetails.name + " is being assigned for further actions"

            }

          }
          this.ValidLcaForm = true;
          this.showCommentPopup = true;

        } else {
          this.ValidLcaForm = false;
          this.showCommentPopup = false;
          this.comments = '';
          const $ = JQuery;

          $('html, body').animate({
            scrollTop: ($('.text-danger').first().offset().top)
          }, 200);

          // const firstField = Object.keys(this.errors.collect())[0];
          // const ele = $("[name=" + firstField + "]").parents(".vx-col");
          //  $("html, body").animate({ scrollTop: ele.offset().top }, 2000);
        }

      })

    },
    submitAction() {
      this.updateEndClient();
      this.updateEmployerPetitioner();
      this.formErrors = '';
      this.$validator.validateAll("activityfoform").then((result) => {
        if (result && this.ValidLcaForm) {
          this.lcaSaveCompleted = false;
          this.lawFirmsubmitCompleted = false;


          this.saveLCAInfo();


        }

      });

    },

    submitToLawFirm() {
      let self =this;
      this.formErrors = '';
      let postData = {
        petitionId: this.getPetitionDetails['_id'],
        comment: this.comments,
        action: "SUBMIT_TO_LAW_FIRM", // "SUBMIT_TO_LAW_FIRM", // "CASE_APPROVED" / "LCA_CERTIFIED_FOR_PETITION" / "SUBMIT_TO_USCIS" / "USCIS_APPROVED" / "USCIS_RECEIVED_RFE" / "USCIS_DENIED" 
        today: moment().format('YYYY-MM-DD'), // Required on Status changes to "Received RFE"
        "typeId": self.checkProperty(self.getPetitionDetails,'typeDetails','id' ),
        "typeName":self.checkProperty(self.getPetitionDetails,'typeDetails','name' ),
        "subTypeId":self.checkProperty(self.getPetitionDetails,'subTypeDetails','id' ), 
        "subTypeName":self.checkProperty(self.getPetitionDetails,'subTypeDetails','name' ),

      };
      this.$validator.validateAll("activityfoform").then((result) => {
        if (result) {

          this.$store
            .dispatch("commonAction", { "data": postData, "path": "/petition/manage-approval-process" })
            .then(response => {

              //lca_request_msg
              this.lca_request_msg = response.message
              this.showToster({ message: response.message, isError: false });
              // this.showCommentPopup =false;
              this.comments = '';
              this.lawFirmsubmitCompleted = true;
              this.reFreshPage();


            })
            .catch((error) => {
              this.formErrors = error;
            })




        }
      });


    },
    init() {

      if (this.checkProperty(this.getPetitionDetails, 'curWorkflowActivity') && this.checkProperty(this.getPetitionDetails, 'nextWorkflowActivity')) {
        let workFlowDetails  = this.getWorkFlowDetails;
        if(workFlowDetails && workFlowDetails.config){
          this.currentWorkFlow = _.find(workFlowDetails.config, { "code": this.getPetitionDetails.curWorkflowActivity });
          this.nextWorkWorkFlow = _.find(workFlowDetails.config, { "code": this.getPetitionDetails.nextWorkflowActivity });
        }
        

      }
      this.lcaInfo = Object.assign(this.lcaInfo, { petitionId: '', typeName: '', subTypeName: '', "today": moment().format("YYYY-MM-DD") });

      if (_.has(this.getPetitionDetails, '_id')) {
        let petitionId = this.getPetitionDetails['_id'];
        this.lcaInfo['petitionId'] = petitionId;

      }

      if (_.has(this.getPetitionDetails, 'typeDetails')) {
        let typeDetails = this.getPetitionDetails['typeDetails'];
        this.lcaInfo['typeName'] = typeDetails['name'];

      }

      if (_.has(this.getPetitionDetails, 'subTypeDetails')) {
        let subTypeDetails = this.getPetitionDetails['subTypeDetails'];
        this.lcaInfo['subTypeName'] = subTypeDetails['name'];

      }

      //{{getLcaDetails lcaInfo}}
      if (this.checkProperty(this.getLcaDetails, "secondaryWorkAddress", 'line1')) {
        this.lcaInfo.secondarlocation = "1";
      }


      if (!this.checkProperty(this.getLcaDetails, 'internalEmployee')) {
        let lcaDetails = this.getLcaDetails;
        if (this.checkProperty(lcaDetails, 'layerInfo', 'length') > 0) {
          let layerInfo = _.cloneDeep(lcaDetails['layerInfo']);

          this.lcaInfo['layerInfo'] = [];

          _.forEach(layerInfo, (client) => {
            //["Employer/Petitioner" ,'End-client'].indexOf(this.checkProperty(client ,'layerType')) >-1 &&
            if (['Mid-Vendor', 'Prime-Vendor', 'Implementation Partner'].indexOf(this.checkProperty(client, 'layerType')) > -1) {
              this.lcaInfo['betweenClients'].push(client);
            } else {
              this.lcaInfo['layerInfo'].push(client);
            }

          })
        }

      }
      if(this.getLcaDetails){
        let lcaDetails = this.getLcaDetails;
        if(_.has(lcaDetails,'internalEmployee')){
          this.useEmployeeAdress = lcaDetails['internalEmployee']
        }
      }
     

      // if (!this.checkProperty(this.getLcaDetails, '_id') && [50].indexOf(this.getUserRoleId) > -1) {
      //   _.forEach(this.lcaInfo['layerInfo'], (item) => {
      //     if (this.checkProperty(item, 'layerType') == "Employer/Petitioner") {
      //       item.employerName = this.checkProperty(this.getUserData, 'companyDetails', "name");
      //     }

      //   })
      // }


    },
    resetLca() {
      this.document = []
      this.lcastatusSelected = null;
      this.lcaStatusDate = null;
      this.useEmployeeAdress = false;
      this.updatingLca = false,

        this.lcaInfo = {

          "today": moment().format("YYYY-MM-DD"),
          everPetiWillfulViolator:'', //'No',
          everBenefiWorkOffsiteAtCompOrOrg:'', //'No',

          invPosiServicesThridPartEntity:'', //'No',
          invPosiBeneficiaryThridPartEntity:'', //'No',
          otherEntitiesInvPlacement:'', //'No',
          petitionId: '',
          typeName: '',
          subTypeName: '',
          secondarlocation: "0",
          highestDegree: null,
          highestDegreeDetails: null,
          hoursPerWeek: null,
          fullTimePosition: null,
          empEndDate: null,
          empStartDate: null,
          mastersDegree: {
            schoolName: "",
            major: "",
          },
          jobTitle: "",
          jobDuties: "",
          multiJobDuties:[
            {
              content:''
            },
            {
              content:''
            },
            {
              content:''
            },
            {
              content:''
            },
            {
              content:''
            },
            {
              content:''
            },
            {
              content:''
            },
            {
              content:''
            }
          ],
          educations:[

          {
              "mastersDegree": { "schoolName": "", "major": "" },
              "highestDegree": null,
              "highestDegreeDetails": null
          }

          ],
          clientName: "",
          internalEmployee: null,
          workAddress: {
            line1: "",
            line2: "",
            zipcode: "",
            countryId: "231",
            stateId: "",
            locationId: "",
            "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
            stateDetails: null,
            locationDetails: null,
            aptType: ''
          },
          secondaryWorkAddress: {
            line1: "",
            line2: "",
            zipcode: "",
            countryId: "231",
            stateId: "",
            locationId: "",
            "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
            stateDetails: null,
            locationDetails: null,
            aptType: ''
          },
          salary: '',
          wageLevel: '',
          payFrequency: 'Year',
          position: '',
          desiredSOCCode: '',
          preferredSOCCode: '',
          socDetails: null,
          preferredSocDetails: null,

          "workAddressCompanyName": '',
          "secondaryWorkAddressCompanyName": '',
          "empWorkForAnyThirdParty": false,
          "noOfLayersBetweenClient": null,
          layerInfo: [
            {
              "layerType": "Employer/Petitioner",
              "employerName": ""
            },
            {
              "layerType": "End-client",
              "employerName": ""
            }
          ],
          betweenClients: [],
          "noOfEmployeeOnYourPayroll": null,
          "noOfEmployeesOnH1bOrL1": null,
          "totalExpInYears": null,
          "yearsOfExpRequiredForLCA":false,
          multipleJobDutiesForLCA:false,

          workAddresses: [
            {
              "companyName": "",
              "workLocation": '',
              line1: "",
              line2: "",
              zipcode: "",
              countryId: "231",
              stateId: "",
              locationId: "",
              "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
              stateDetails: null,
              locationDetails: null,
              aptType: ''
            }

          ],
        }



      if (_.has(this.getPetitionDetails, '_id')) {
        let petitionId = this.getPetitionDetails['_id'];
        this.lcaInfo['petitionId'] = petitionId;

      }

      if (_.has(this.getPetitionDetails, 'typeDetails')) {
        let typeDetails = this.getPetitionDetails['typeDetails'];
        this.lcaInfo['typeName'] = typeDetails['name'];

      }

      if (_.has(this.getPetitionDetails, 'subTypeDetails')) {
        let subTypeDetails = this.getPetitionDetails['subTypeDetails'];
        this.lcaInfo['subTypeName'] = subTypeDetails['name'];

      }
      this.prepopulateEducations()
      this.$validator.reset();
      this.$validator.reset();


      this.countrySelected = {
        _id: "5db7f7409419e34350f11024",
        id: 231,
        name: "United States",
      }
      this.selectCountry(this.countrySelected);

      this.secondcountrySelected = {
        _id: "5db7f7409419e34350f11024",
        id: 231,
        name: "United States",
      }

      this.updateEndClient();
      this.updateEmployerPetitioner();

    },
    //selectWage ll_wage_lavels:[],
    //selectedWage:null
    selectWage(option) {
      this.lcaInfo.wageLevel = option.id;

    },
    getSalary_wiseLavel() {
      this.$store
        .dispatch("getwiseLavel")
        .then(response => {
          this.all_wage_lavels = response;
          // alert(this.all_wage_lavels);

        });
    },
    upload(model,category = '') {
      let cateory = category;
      let temp_count = 0;
     
      this.disabled_btn = false;
      let mapper = model.map(
        item =>
        (item = {
          name: item.name,
          file: item.file ? item.file : null,
          path: item.path ? item.path : "",
          mimetype: item.type ? item.type : item.mimetype,
          status: true,
          uploadedBy: this.checkProperty(this.getUserData, 'userId'),
          uploadedByName: this.checkProperty(this.getUserData, 'name'),
          uploadedByRoleId: this.getUserRoleId,
          uploadedByRoleName: this.checkProperty(this.getUserData, 'loginRoleName'),
          size:item.size ? item.size : null,
        })
      );
      if (mapper.length > 0) {
        this.$vs.loading();
        //this.$vs.loading();
        mapper.forEach((doc, index) => {
          let formData = new FormData();
          if ((doc.mimetype == "application/pdf" || doc.type == "application/pdf")) {
            this.disabled_btn = true;

            formData.append("files", doc.file);
            formData.append("secureType", "private");
            formData.append("getDetails", true);
            this.$store.dispatch("uploadS3File", formData).then(response => {
              temp_count++;
              response.data.result.forEach(urlGenerated => {
                
                doc.path = urlGenerated["path"];
                if(_.has(urlGenerated ,'size' )){
                  doc['size'] = urlGenerated['size'];
                }
                if(cateory != 'others'){
                  this.extractFileData(doc.path);
                }
                

                

                delete doc.file;
                mapper[index] = doc;
                if(cateory == 'others'){
                    this.others.push(doc);
                }

                if (temp_count >= mapper.length) {
                  this.disabled_btn = false;
                  // this.$vs.loading.close();
                }
                if(cateory == 'others'){
                  this.$vs.loading.close();
                }
              });
            });
          }else {
            this.showToster({ message: "Upload only pdf files ", isError: true });
            setTimeout(() => {
              this.$vs.loading.close();
              this.document = [];
               this.$validator.reset();
              }, 100) 
            
          }
        });
        model.splice(0, mapper.length, ...mapper);
      }
    },
    uploadOther(model,category = ''){
      let cateory = category;
      let total_files = model.length;
      let temp_count = 0;
      this.disabled_btn_others = false;
      let mapper = model.map(
        item =>
        (item = {
          name: item.name,
          file: item.file ? item.file : null,
          path: item.path ? item.path : "",
          mimetype: item.type ? item.type : item.mimetype,
          status: true,
          uploadedBy: this.checkProperty(this.getUserData, 'userId'),
          uploadedByName: this.checkProperty(this.getUserData, 'name'),
          uploadedByRoleId: this.getUserRoleId,
          uploadedByRoleName: this.checkProperty(this.getUserData, 'loginRoleName'),
          size:item.size ? item.size : null,
        })
      );
      if (mapper.length > 0) {
        this.$vs.loading();
        //this.$vs.loading();
        mapper.forEach((doc, index) => {
          let formData = new FormData();
          if ((doc.mimetype == "application/pdf" || doc.type == "application/pdf")) {

            this.disabled_btn_others = true;

            formData.append("files", doc.file);
            formData.append("secureType", "private");
            formData.append("getDetails", true);
            this.$store.dispatch("uploadS3File", formData).then(response => {
              //temp_count++;
              temp_count++; 
              response.data.result.forEach(urlGenerated => {
                
                doc.path = urlGenerated["path"];
                if(_.has(urlGenerated ,'size' )){
                  doc['size'] = urlGenerated['size'];
                }
                
                delete doc.file;
                mapper[index] = doc;
                if(cateory == 'others'){
                    this.others.push(doc);
                    this.$vs.loading.close();
                }

                if (temp_count === total_files) {
                  this.disabled_btn_others = false;
                   this.$vs.loading.close();
                }
                if(cateory == 'others'){
                  this.$vs.loading.close();
                }
              });
            });
          }else {
            temp_count++;
            if (temp_count === total_files) {
              this.showToster({ message: "Upload only pdf files ", isError: true });
            setTimeout(() => {
              this.disabled_btn_others=false;
              this.$vs.loading.close();
              this.document = [];
               this.$validator.reset();
              }, 100)
            }
             
            
          }
        });
        model.splice(0, mapper.length, ...mapper);
      }
     
    },
  
    remove(item, type) {
      if (!this.disabled_btn) {
        let doc=type[item]
        type.splice(item, 1);
        this.removeFileFromS3(doc)
        // if(type == 'others'){
        //   this.others.splice(item, 1);
        // }else{
        //   type.splice(item, 1);
        // }
        
      }

      // item.status = false;
      // type[type.indexOf(item)] = item;
      return true;
    },
    remove_others(item, type){
      if ( !this.disabled_btn_others) {
        type.splice(item, 1);
      }
      return true;
    },
    scrollHandle(evt) {
    },
    reloadthePage() {
      this.$router.go("/cases");
    },
    selectCountry(option) {
      this.stateSelected = null;
      this.locationSelected = null;
      this.lcaInfo.workAddress.countryId = option.id;

      this.lcaInfo.workAddress.stateId = '';
      this.lcaInfo.workAddress.locationId = '';

      this.get_all_states();
    },
    selecsecondtCountry(option) {
      this.secondstateSelected = null;
      this.secondlocationSelected = null;
      this.lcaInfo.secondaryWorkAddress.countryId = option.id;

      this.lcaInfo.secondaryWorkAddress.stateId = '';
      this.lcaInfo.secondaryWorkAddress.locationId = '';

      this.get_second_all_states();
    },
    selectState(option) {
      this.locationSelected = null;
      this.lcaInfo.workAddress.stateId = option.id;
      this.lcaInfo.workAddress.locationId = '';
      this.getLocations();
    },
    selectLocation(option) {
      this.lcaInfo.workAddress.locationId = option.id;
    },
    get_all_states() {
      this.$store
        .dispatch("getstates", this.lcaInfo.workAddress.countryId)
        .then(response => {
          this.all_states = response;
        });
    },
    getLocations() {
      let obj = {
        stateId: this.lcaInfo.workAddress.stateId,
        countryId: this.lcaInfo.workAddress.countryId
      };
      this.$store.dispatch("getlocations", obj).then(response => {
        this.locations = response;
      });
    },

    selectsecondCountry(option) {
      this.lcaInfo.secondaryWorkAddress.countryId = option.id;
      this.get_second_all_states();
    },
    selectsecondState(option) {
      this.secondlocationSelected = null;
      this.lcaInfo.secondaryWorkAddress.stateId = option.id;
      this.getsecondLocations();
    },
    selectedsecondLocations(option) {
      this.lcaInfo.secondaryWorkAddress.locationId = option.id;

    },
    get_second_all_states() {
      this.$store
        .dispatch("getstates", this.lcaInfo.secondaryWorkAddress.countryId)
        .then(response => {
          this.all_second_states = response;
        });
    },
    getsecondLocations() {
      let obj = {
        stateId: this.lcaInfo.secondaryWorkAddress.stateId,
        countryId: this.lcaInfo.secondaryWorkAddress.countryId
      };
      this.$store.dispatch("getlocations", obj).then(response => {
        this.secondlocations = response;
      });
    },
    reloadpage() {
      this.submitedlca = false;
      setTimeout(() => {


        window.location.reload();
      }, 10)
    },

    saveLCAInfo(saveOnlyLca = false) {

      if((this.checkProperty(this.getLcaDetails, 'multiEduDetailsForLCA') == true) || (this.checkProperty(this.configDetails, 'multiEduDetailsForLCA') == true && !this.checkProperty(this.getLcaDetails, '_id'))){
        //lcaInfo['educations']
        //lcaInfo.highestDegreeDetails
        let mastersDegree = null;
        let bachelorsDegree = null;// _.find(this.lcaInfo['educations'] , { "highestDegreeDetails.id":4});
        _.forEach(this.lcaInfo['educations'] ,(edu)=>{
          if(edu && this.checkProperty(edu , 'highestDegreeDetails' ,'id')==6 ){
            
            mastersDegree = edu
          }
          if(edu && this.checkProperty(edu , 'highestDegreeDetails' ,'id')==4 ){
            
            bachelorsDegree = edu
          }

        });
        //alert(JSON.stringify(mastersDegree));
       
       
      }
      
      let self = this;
      //this.$validator.validateAll().then(result => {
      if (this.ValidLcaForm) {
        this.updatingLca = true
        if (this.checkProperty(this.getPetitionDetails, '_id') && !this.callFromActionPopup) {
          Object.assign(this.lcaInfo, {
            petitionId: this.getPetitionDetails._id,
            petitionerId: this.getPetitionDetails.petitionerId,
            userId: this.getPetitionDetails.userId,
            today: moment().format("YYYY-MM-DD"),
            petitionCaseNo: this.getPetitionDetails.caseNo,
            beneficiaryName: this.getPetitionDetails.beneficiaryDetails.name,
            petitionerName: this.getPetitionDetails.createdByDetails.name,

            lcastatusSelected: this.lcastatusSelected,
            documents: {
              filed: [],
              certified: [],
              others:[]
            },
            type: this.checkProperty(this.getPetitionDetails, 'typeDetails', 'name'),
            subType: this.checkProperty(this.getPetitionDetails, 'subTypeDetails', 'name'),
            typeName: this.checkProperty(this.getPetitionDetails, 'typeDetails', 'name'),
            subTypeName: this.checkProperty(this.getPetitionDetails, 'subTypeDetails', 'name'),
            action: this.uploadlca == 'true' ? "LCA_SUBMIT" : "LCA_REQUEST",

          });
        } else {
          Object.assign(this.lcaInfo, {
            // petitionId: this.getPetitionDetails._id,
            // petitionerId: this.getPetitionDetails.petitionerId,
            //  userId: this.getPetitionDetails.userId,
            today: moment().format("YYYY-MM-DD"),
            //  petitionCaseNo: this.getPetitionDetails.caseNo,
            //  beneficiaryName: this.getPetitionDetails.beneficiaryDetails.name,
            //  petitionerName: this.getPetitionDetails.createdByDetails.name,

            lcastatusSelected: this.lcastatusSelected,
            documents: {
              filed: [],
              certified: [],
              others:[]
            },
            //  type:this.checkProperty(this.getPetitionDetails,'typeDetails','name'),
            //  subType:this.checkProperty(this.getPetitionDetails,'subTypeDetails','name'),
            //  typeName:this.checkProperty(this.getPetitionDetails,'typeDetails','name'),
            //  subTypeName:this.checkProperty(this.getPetitionDetails,'subTypeDetails','name'),
            action: this.uploadlca == 'true' ? "LCA_SUBMIT" : "LCA_REQUEST",
          });

          Vue.delete(this.lcaInfo, 'petitionId');

          // if ([50].indexOf(this.getUserRoleId) > -1 && this.checkProperty(this.getUserData, 'userId')) {
          //   this.lcaInfo['petitionerId'] = this.checkProperty(this.getUserData, 'userId')
          //   if (this.checkProperty(this.getUserData, 'name')) {
          //     this.lcaInfo['petitionerName'] = this.checkProperty(this.getUserData, 'name')
          //   }
          // }
          // if (this.getTenantTypeId == 2 && this.checkProperty(this.getUserData, 'tenantDetails', 'userId')) {
          //   this.lcaInfo['petitionerId'] = this.checkProperty(this.getUserData, 'tenantDetails', 'userId')
          //   if (this.checkProperty(this.getUserData, 'tenantDetails', 'name')) {
          //     this.lcaInfo['petitionerId'] = this.checkProperty(this.getUserData, 'tenantDetails', 'name');
          //   } else {
          //     this.lcaInfo['petitionerId'] = this.checkProperty(this.getUserData, 'tenantDetails', 'adminName');
          //   }
          // }


        }

        if (this.lcaInfo.secondarlocation <= 0) {

          this.lcaInfo['secondaryWorkAddress'] = {
            line1: "",
            line2: "",
            zipcode: "",
            countryId: 231,
            countryDetails: { "_id": "61408c9ed01ea1248cdcf6b7", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
            stateId: null,
            locationId: null,
            stateDetails: null,
            locationDetails: null,
            aptType: '',
            workLocation: null
          }
          this.lcaInfo.secondaryWorkAddressCompanyName = '';
        }

        if (this.lcaInfo.statusId == 2) {

          Object.assign(this.lcaInfo['documents'], { 'filed': this.document });


          let lcaStatusDate = moment(this.lcaStatusDate).format("YYYY-MM-DD");
          Object.assign(this.lcaInfo, { "filedDate": lcaStatusDate });


        } else if (this.lcaInfo.statusId == 3) {

          Object.assign(this.lcaInfo['documents'], { 'certified': this.document })
          let lcaStatusDate = moment(this.lcaStatusDate).format("YYYY-MM-DD");
          Object.assign(this.lcaInfo, { "certifiedDate": lcaStatusDate });
        }
        Object.assign(this.lcaInfo['documents'], { 'others': this.others })
        
        this.$vs.loading();
        this.submtingForm = true;
        this.lcaInfo['noOfLayersBetweenClient'] = this.checkProperty(this.lcaInfo['betweenClients'], length);
        let postData = _.cloneDeep(this.lcaInfo);

        if (!this.checkProperty(this.lcaInfo, 'internalEmployee')) {

          postData['empWorkForAnyThirdParty'] = true;
          //betweenClients
          if (this.checkProperty(postData, 'betweenClients', 'length') > 0 && this.checkProperty(postData, 'layerInfo', 'length') > 0) {

            let layerInfo = _.cloneDeep(postData['layerInfo']);
            let finalLayerInfo = [];
            finalLayerInfo.push(layerInfo[0]);
            _.forEach(postData['betweenClients'], (item) => {
              finalLayerInfo.push(item);

            })
            if (this.checkProperty(layerInfo, 'length') > 1) {
              finalLayerInfo.push(layerInfo[1]);
            }
            postData = Object.assign(postData, { 'layerInfo': [] });
            _.forEach(finalLayerInfo, (client) => {
              if (["Employer/Petitioner", 'End-client'].indexOf(this.checkProperty(client, 'layerType')) > -1 || ['Mid-Vendor', 'Prime-Vendor', 'Implementation Partner'].indexOf(this.checkProperty(client, 'layerType')) > -1) {
                postData['layerInfo'].push(client);
              }

            })






          }
        } else {
          postData['layerInfo'] = [];
          this.lcaInfo['noOfLayersBetweenClient'] = 0;
          postData['empWorkForAnyThirdParty'] = false;

        }
        postData['highestDegree'] = this.checkProperty(postData, 'highestDegreeDetails', 'id')

        if (!this.checkProperty(this.lcaInfo, 'fullTimePosition') && this.checkProperty(this.lcaInfo, 'hoursPerWeek') > 0) {

          postData['hoursPerWeek'] = parseInt(this.lcaInfo['hoursPerWeek'])

        }
        //alert(JSON.stringify(postData)); lcaInfo.socDetails" desiredSOCCode


        if ([2, 3].indexOf(this.lcaInfo.statusId) > -1) {

          postData['desiredSOCCode'] = this.checkProperty(this.lcaInfo, 'socDetails', 'id');
        } else {
          postData['preferredSOCCode'] = this.checkProperty(this.lcaInfo, 'preferredSocDetails', 'id');


        }


        //"innerAction": "UPDATE_BASIC_INFO",

        if (!this.checkProperty(this.configDetails, 'yearsOfExpRequiredForLCA')) {
          postData['totalExpInYears'] = 0;
        }
        postData['submittedWithLink'] = false;
        if (this.checkProperty(this.$route, 'name') == 'fill-lca-anonymous-user') {
          postData['submittedWithLink'] = true;
        }

        postData = Object.assign(postData, { "consentChecked": this.consentChecked, "termsAndConditionsChecked": this.termsAndConditionsChecked });
        postData = Object.assign(postData, { "allowToAddLCALayers": false, "yearsOfExpRequiredForLCA": false });
        postData['allowToAddLCALayers'] = this.checkProperty(this.configDetails, 'allowToAddLCALayers') == true ? true : false;
        postData['yearsOfExpRequiredForLCA'] = this.checkProperty(this.configDetails, 'yearsOfExpRequiredForLCA') == true ? true : false;

        postData['addressEntityIOrHomeForLCA'] = this.checkProperty(this.configDetails, 'addressEntityIOrHomeForLCA') == true ? true : false;
        postData['multipleJobDutiesForLCA'] = this.checkProperty(this.configDetails, 'multipleJobDutiesForLCA') == true ? true : false;
        postData['multiEduDetailsForLCA'] = this.checkProperty(this.configDetails, 'multiEduDetailsForLCA') == true ? true : false;



        if ([50].indexOf(this.getUserRoleId) > -1) {
          // postData =Object.assign(postData , {'petitionerId':''});
          // postData['petitionerId'] = this.petitionerDetails['_id'];

        } else if (this.checkProperty(this.petitionerDetails, "_id") && this.isFromLCAList && this.getTenantTypeId != 2 && [50].indexOf(this.getUserRoleId) <= -1) {
          postData = Object.assign(postData, { 'petitionerId': '' });
          postData['petitionerId'] = this.petitionerDetails['_id'];
        }
        let pathdt = 'savelcadetails';
        if(this.checkProperty(this.getLcaDetails, 'statusId') ==99 &&this.checkProperty(this.getLcaDetails, '_id')){
          postData['action'] = "LCA_SUBMIT";
          postData['statusId'] = 1;
          postData['lcaId'] = this.checkProperty(this.getLcaDetails, '_id');
          postData['innerAction'] =  "UPDATE_BASIC_INFO";
          postData['updateType'] = "basic-info";
          pathdt = 'updateLcaDetails'
        }

        this.$store.dispatch(pathdt, postData)
          .then(response => {
            this.updatingLca = false
            this.submtingForm = false;
            this.$vs.loading.close();

            if (this.lcastatusSelected != null && (_.has(this.lcastatusSelected, "id"))) {
              if (this.lcastatusSelected.id == 2) { // In process
                this.lca_request_msg = "Proof of LCA processing submitted successfully!"

              }
              if (this.lcastatusSelected.id == 3) { // certified
                this.lca_request_msg = "LCA certificate submitted successfully!"

              }
            }

            if (!saveOnlyLca) {

              if (this.checkProperty(response, 'error')) {
                // alert(" EOORR")
                if (this.checkProperty(response, 'error', 'code') == 'LCA_ALREADY_LINKED') {
                  this.lcaSaveCompleted = true;
                  this.submitedlca = false;
                  this.$vs.loading.close();
                  this.submitToLawFirm();
                  this.reFreshPage()
                  // this.showMessages({ message:this.checkProperty(response , 'error' ,"message") ,isError:false});

                } else {
                  this.formErrors = this.checkProperty(response, 'error', "message");

                }


              } else {

                // alert("NO EOORR")

                this.lcaSaveCompleted = true;
                this.submitedlca = true;
                this.$vs.loading.close();
                this.submitToLawFirm();
                this.reFreshPage()

                /*
                this.$vs.loading.close();
              
                document.addEventListener("click", this.reloadpage);
                */
              }
            } else {
              // alert(JSON.stringify(response))

              if (this.isFromLCAList) {
                this.reFreshPage(true);
                if(this.callFromActionPopup){
                  
                if(this.checkProperty(response['data']['result'],'_id')){
                  this.showToster({ message: self.checkProperty(response, "data", "message"), isError: false });
                  let obj={
                    _id : this.checkProperty(response['data']['result'],'_id'),
                    caseNo : this.checkProperty(response['data']['result'],'caseNo')
                  }
                  this.$emit('changeLCA',obj)
                }else{
                  this.showToster({ message: self.checkProperty(response, "data", "message"), isError: false });
                }
                  
                }
              } else {
                this.showToster({ message: self.checkProperty(response, "data", "message"), isError: false });
                this.submitedlca = true;
                this.reFreshPage(true);
              }

            }

          }).catch((error) => {
            this.updatingLca = false
            if (!saveOnlyLca) {
              if (this.checkProperty(error, 'code') == 'LCA_ALREADY_LINKED') {

                this.lcaSaveCompleted = true;
                this.submitedlca = false;
                this.$vs.loading.close();
                this.submitToLawFirm();
                this.reFreshPage()
                this.formErrors = this.checkProperty(error, "message");
                // this.showMessages({ message:this.checkProperty(response , 'error' ,"message") ,isError:false});

              } else {
                this.lcaSaveCompleted = false;
                this.$vs.loading.close();
                this.formErrors = this.checkProperty(error, "message");
                this.submtingForm = false;
              }
            } else {
              self.ValidLcaForm = false;
              this.$vs.loading.close();
              self.showToster({ message: self.checkProperty(error, "message"), isError: true });

            }



          })
      } else {
        // const $ = JQuery;
        //const firstField = Object.keys(this.errors.collect())[0];
        // const ele = $("[name=" + firstField + "]").parents(".vx-col");
        //  $("html, body").animate({ scrollTop: ele.offset().top }, 2000);

        this.validateandScroll();
      }
      //});
    },
    saveLcaDraft(calFromPetition = false){
      if((this.checkProperty(this.getLcaDetails, 'multiEduDetailsForLCA') == true) || (this.checkProperty(this.configDetails, 'multiEduDetailsForLCA') == true && !this.checkProperty(this.getLcaDetails, '_id'))){
        let mastersDegree = null;
        let bachelorsDegree = null;
        _.forEach(this.lcaInfo['educations'] ,(edu)=>{
          if(edu && this.checkProperty(edu , 'highestDegreeDetails' ,'id')==6 ){     
            mastersDegree = edu
          }
          if(edu && this.checkProperty(edu , 'highestDegreeDetails' ,'id')==4 ){      
            bachelorsDegree = edu
          }
        });
      }
      let self = this;
     
        this.updatingLca = true
        if (this.checkProperty(this.getPetitionDetails, '_id')) {
          Object.assign(this.lcaInfo, {
            petitionId: this.getPetitionDetails._id,
            petitionerId: this.getPetitionDetails.petitionerId,
            userId: this.getPetitionDetails.userId,
            today: moment().format("YYYY-MM-DD"),
            petitionCaseNo: this.getPetitionDetails.caseNo,
            beneficiaryName: this.getPetitionDetails.beneficiaryDetails.name,
            petitionerName: this.getPetitionDetails.createdByDetails.name,
            lcastatusSelected: this.lcastatusSelected,
            documents: {
              filed: [],
              certified: [],
              others:[]
            },
            type: this.checkProperty(this.getPetitionDetails, 'typeDetails', 'name'),
            subType: this.checkProperty(this.getPetitionDetails, 'subTypeDetails', 'name'),
            typeName: this.checkProperty(this.getPetitionDetails, 'typeDetails', 'name'),
            subTypeName: this.checkProperty(this.getPetitionDetails, 'subTypeDetails', 'name'),
            action: "LCA_DRAFT",
            statusId:99
          });
        } else {
          Object.assign(this.lcaInfo, {
            today: moment().format("YYYY-MM-DD"),
            lcastatusSelected: this.lcastatusSelected,
            documents: {
              filed: [],
              certified: [],
              others:[]
            },
            action: "LCA_DRAFT",
            statusId:99
          });

          Vue.delete(this.lcaInfo, 'petitionId');
        }
        if (this.lcaInfo.secondarlocation <= 0) {
          this.lcaInfo['secondaryWorkAddress'] = {
            line1: "",
            line2: "",
            zipcode: "",
            countryId: 231,
            countryDetails: { "_id": "61408c9ed01ea1248cdcf6b7", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
            stateId: null,
            locationId: null,
            stateDetails: null,
            locationDetails: null,
            aptType: '',
            workLocation: null
          }
          this.lcaInfo.secondaryWorkAddressCompanyName = '';
        }
        if (this.lcaInfo.statusId == 2) {
          Object.assign(this.lcaInfo['documents'], { 'filed': this.document });
          let lcaStatusDate = moment(this.lcaStatusDate).format("YYYY-MM-DD");
          Object.assign(this.lcaInfo, { "filedDate": lcaStatusDate });
        } else if (this.lcaInfo.statusId == 3) {
          Object.assign(this.lcaInfo['documents'], { 'certified': this.document })
          let lcaStatusDate = moment(this.lcaStatusDate).format("YYYY-MM-DD");
          Object.assign(this.lcaInfo, { "certifiedDate": lcaStatusDate });
        }
        Object.assign(this.lcaInfo['documents'], { 'certified': this.others })
        
        this.$vs.loading();
        this.submtingForm = true;
        this.lcaInfo['noOfLayersBetweenClient'] = this.checkProperty(this.lcaInfo['betweenClients'], length);
        let postData = _.cloneDeep(this.lcaInfo);
        if (!this.checkProperty(this.lcaInfo, 'internalEmployee')) {
          postData['empWorkForAnyThirdParty'] = true;
          if (this.checkProperty(postData, 'betweenClients', 'length') > 0 && this.checkProperty(postData, 'layerInfo', 'length') > 0) {
            let layerInfo = _.cloneDeep(postData['layerInfo']);
            let finalLayerInfo = [];
            finalLayerInfo.push(layerInfo[0]);
            _.forEach(postData['betweenClients'], (item) => {
              finalLayerInfo.push(item);
            })
            if (this.checkProperty(layerInfo, 'length') > 1) {
              finalLayerInfo.push(layerInfo[1]);
            }
            postData = Object.assign(postData, { 'layerInfo': [] });
            _.forEach(finalLayerInfo, (client) => {
              if (["Employer/Petitioner", 'End-client'].indexOf(this.checkProperty(client, 'layerType')) > -1 || ['Mid-Vendor', 'Prime-Vendor', 'Implementation Partner'].indexOf(this.checkProperty(client, 'layerType')) > -1) {
                postData['layerInfo'].push(client);
              }
            })
          }
        } else {
          postData['layerInfo'] = [];
          this.lcaInfo['noOfLayersBetweenClient'] = 0;
          postData['empWorkForAnyThirdParty'] = false;
        }
        postData['highestDegree'] = this.checkProperty(postData, 'highestDegreeDetails', 'id')
        if (!this.checkProperty(this.lcaInfo, 'fullTimePosition') && this.checkProperty(this.lcaInfo, 'hoursPerWeek') > 0) {
          postData['hoursPerWeek'] = parseInt(this.lcaInfo['hoursPerWeek'])
        }
        if ([2, 3].indexOf(this.lcaInfo.statusId) > -1) {
          postData['desiredSOCCode'] = this.checkProperty(this.lcaInfo, 'socDetails', 'id');
        } else {
          postData['preferredSOCCode'] = this.checkProperty(this.lcaInfo, 'preferredSocDetails', 'id');
        }
        if (!this.checkProperty(this.configDetails, 'yearsOfExpRequiredForLCA')) {
          postData['totalExpInYears'] = 0;
        }
        postData['submittedWithLink'] = false;
        if (this.checkProperty(this.$route, 'name') == 'fill-lca-anonymous-user') {
          postData['submittedWithLink'] = true;
        }
        postData = Object.assign(postData, { "termsAndConditionsChecked": this.termsAndConditionsChecked, "consentChecked": this.consentChecked });
        postData = Object.assign(postData, { "allowToAddLCALayers": false, "yearsOfExpRequiredForLCA": false });
        postData['allowToAddLCALayers'] = this.checkProperty(this.configDetails, 'allowToAddLCALayers') == true ? true : false;
        postData['yearsOfExpRequiredForLCA'] = this.checkProperty(this.configDetails, 'yearsOfExpRequiredForLCA') == true ? true : false;
        postData['addressEntityIOrHomeForLCA'] = this.checkProperty(this.configDetails, 'addressEntityIOrHomeForLCA') == true ? true : false;
        postData['multipleJobDutiesForLCA'] = this.checkProperty(this.configDetails, 'multipleJobDutiesForLCA') == true ? true : false;
        postData['multiEduDetailsForLCA'] = this.checkProperty(this.configDetails, 'multiEduDetailsForLCA') == true ? true : false;
        if ([50].indexOf(this.getUserRoleId) > -1) {
        } else if (this.checkProperty(this.petitionerDetails, "_id") && this.isFromLCAList && this.getTenantTypeId != 2 && [50].indexOf(this.getUserRoleId) <= -1) {
          postData = Object.assign(postData, { 'petitionerId': '' });
          postData['petitionerId'] = this.petitionerDetails['_id'];
        }
        let actionMethod = 'savelcadetails'
        if(this.tempLcaId){
          postData['lcaId'] = this.tempLcaId;
          postData['updateType']= "basic-info"
          postData['innerAction']= "UPDATE_BASIC_INFO"
          actionMethod = 'updateLcaDetails';
        }
        
        
        this.$store.dispatch(actionMethod, postData)
          .then(response => {
            
            this.submtingForm = false;
            if(_.has(response['data'],'result') && _.has(response['data']['result'],'_id') && this.checkProperty(response['data']['result'],'_id')){
              this.tempLcaId = this.checkProperty(response['data']['result'],'_id');
            }
            if(calFromPetition && _.has(response['data'],'result') && _.has(response['data']['result'],'_id') && this.checkProperty(response['data']['result'],'_id')){
              this.$emit('reloadLcaDetails',this.checkProperty(response['data']['result'],'_id'));
              this.$store.dispatch("fetchLcaDetails", this.checkProperty(response['data']['result'],'_id')).then((response) => {
                let lcaDetails = response.data.result;
                this.petitionDetails['lcaId'] = this.checkProperty(response['data']['result'],'_id')
                this.$store.dispatch("setPetitionData", {
                  petitionDetails: this.petitionDetails,
                  lcaDetails: lcaDetails,
                
                });
              })
            }
            this.showToster({ message: self.checkProperty(response, "data", "message"), isError: false });
         
            this.updatingLca = false
           this.$vs.loading.close();
          }).catch((error) => {
            this.submtingForm = false;
            this.updatingLca = false
            this.$vs.loading.close();
            if(this.checkProperty(error,'error','clientName')){
              this.showToster({ message: self.checkProperty(error, "error", "clientName"), isError: true });
            }else if(this.checkProperty(error,'error','petitionerId')){
            this.showToster({ message: self.checkProperty(error, "error", "petitionerId"), isError: true });
            }else if(this.checkProperty(error,'message')){
              this.showToster({ message: error.message, isError: true });
            }
          })
      
    },
    validateandScroll() {
      var $self = this;
      const $ = JQuery;
      var el = _.find(this.errors["items"], function (item) {
        return item.scope == $self.currentTab + "form"
      })
      if (el) {
        const ele = $("[name=" + el.field + "]").parents(".vx-col");
        var _top = 0;
        if (ele) {
          _top = ele.position().top;
        }
      }
      document.getElementById("scrollableques").scrollTo({
        top: _top,
        left: 0,
        behavior: 'smooth'
      })

    },
  },
  data: () => ({
    consentData:'',
    termsAndConditionsData:'',
    contentCategory:'',
    showConsentContentPopup:false,
    consentTermsAndCondition:false,
    termsAndConditionsChecked:false, 
    consentChecked:false,
    //// consent End
    isSlg: true,
    selectedMethod:'',
    employeeLcaMsg:'',
    companyAddressDetails:null,
    tempLcaId:'',
    tempReload:false,
    others:[],
    otherDocsTemp:[],
    approveConformpopUp:false,
    documentExtractedMsg:'',
    documentExtractedData:null,

    petitionerDetails: null,
    petitionerList: [],
    configDetails: null,
    preFilling: false,
    fileUploaded: false,
    selectedStatusFromFile: false,
    useEmployeeAdress: false,
    companyDetails: null,
    selectLcaStatusDate: '',
    editorConfig: {
      toolbar: ['bold', 'italic', '|', 'undo', 'redo', 'NumberedList', 'BulletedList',],
    },
    maxEmpError: '',
    editor: ClassicEditor,
    loadBetweens: true,
    availableVendors: ['Mid-Vendor', 'Prime-Vendor', 'Implementation Partner'],
    masterSocList: [],
    switch1: false,
    education_types: [],
    masterEducationsList:[],
    educationsList:[],
    payFrequencyList: ["Hour", "Week", "Month", "Year"],
    payFrequency: "Year",
    submtingForm: false,
    formErrors: '',
    ValidLcaForm: false,
    comments: '',
    showCommentPopup: false,
    currentWorkFlow: null,
    nextWorkWorkFlow: null,
    lcaSaveCompleted: false,
    lawFirmsubmitCompleted: false,
    lca_request_msg: "LCA request submitted successfully!",
    disabled_btn: false,
    disabled_btn_others: false,
    submitedlca: false,
    SubmitParalegal: false,
    settings: "",
    SuccessQuestionnaire: false,
    AssignParalegal: false,
    active: false,
    document: [],
    lcaInfo: {
      "today": moment().format("YYYY-MM-DD"),
      petitionId: '',
      secondarlocation: "0",
      typeName: "",
      subTypeName: "",
      hoursPerWeek: null,
      fullTimePosition: null,
      payFrequency: 'Year',
      empEndDate: null,
      empStartDate: null,
      /*
      documents: {
        filed: [],
        certified:[]
      }, */
      highestDegreeDetails: null,
      highestDegree: null,
      mastersDegree: {
        schoolName: "",
        major: "",

      },

      jobTitle: "",
      jobDuties: "",
      multiJobDuties:[
      {
              content:''
            },
            {
              content:''
            },
            {
              content:''
            },
            {
              content:''
            },
            {
              content:''
            },
            {
              content:''
            },
            {
              content:''
            },
            {
              content:''
            }
          ],
          educations:[

          {
              "mastersDegree": { "schoolName": "", "major": "" },
              "highestDegree": null,
              "highestDegreeDetails": null
          }

          ],
      clientName: "",
      internalEmployee: null,
      workAddresses: [
        {
          "companyName": "",
          "workLocation": '',
          line1: "",
          line2: "",
          zipcode: "",
          countryId: "231",
          stateId: "",
          locationId: "",
          "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
          stateDetails: null,
          locationDetails: null,
          aptType: ''
        }

      ],
      workAddress: {
        line1: "",
        line2: "",
        zipcode: "",
        countryId: "231",
        stateId: "",
        locationId: "",
        "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
        stateDetails: null,
        locationDetails: null,
        aptType: ''
      },
      secondaryWorkAddress: {
        line1: "",
        line2: "",
        zipcode: "",
        countryId: "231",
        stateId: "",
        locationId: "",
        "countryDetails": { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
        stateDetails: null,
        locationDetails: null,
        aptType: ''

      },
      salary: '',
      wageLevel: '',
      position: '',
      desiredSOCCode: '',
      preferredSOCCode: '',
      socDetails: null,
      preferredSocDetails: null,

      "workAddressCompanyName": '',
      "secondaryWorkAddressCompanyName": '',
      "empWorkForAnyThirdParty": false,
      "noOfLayersBetweenClient": null,
      layerInfo: [
        {
          "layerType": "Employer/Petitioner",
          "employerName": ""
        },
        {
          "layerType": "End-client",
          "employerName": ""
        }
      ],
      betweenClients: [],
      "noOfEmployeeOnYourPayroll": null,
      "noOfEmployeesOnH1bOrL1": null,
      "totalExpInYears": null,
      everPetiWillfulViolator:'No',
      everBenefiWorkOffsiteAtCompOrOrg:'No',
      invPosiServicesThridPartEntity:'NO',
      invPosiBeneficiaryThridPartEntity:'NO',
      otherEntitiesInvPlacement:'NO',


    },
    countrySelected: null,
    stateSelected: null,
    locationSelected: null,
    secondcountrySelected: null,
    secondstateSelected: null,
    secondlocationSelected: null,
    note_3: "",
    note_4: "",
    countries: [],
    all_states: [],
    locations: [],
    all_second_states: [],
    secondlocations: [],
    petition: [],
    lcastatuses: [],
    lcastatusSelected: null,
    uploadlca: "false",
    all_wage_lavels: [],
    selectedWage: null,
    required: false,
    lcaStatusDate: null,
    updatingLca: false,

  }),
  mounted() {
    this.getConsentDetails()
    if (this.checkProperty(this.getUserData, 'tenantDetails') && this.checkProperty(this.getUserData, 'tenantDetails', 'slug') != 'slg') {
      this.isSlg = false;
    }
    this.resetLca();
    this.getCompanyAddress()
    //this.prepopulateEducations();
    this.getPeritioners();
    this.fileUploaded = false;
    this.getCompanyDetails();
    this.loadBetweens = true
    this.availableVendors = ['Mid-Vendor', 'Prime-Vendor', 'Implementation Partner'];
    this.getMasterSocList()
    this.showCommentPopup = false;
    this.comments = '';
    this.ValidLcaForm = false;

    this.$store.dispatch("getcountries").then(response => {
      this.$validator.reset();
      this.countries = response;
      this.countrySelected = {
        _id: "5db7f7409419e34350f11024",
        id: 231,
        name: "United States",
      }
      this.secondcountrySelected = {
        _id: "5db7f7409419e34350f11024",
        id: 231,
        name: "United States",
      }
      if (this.checkProperty(this.getLcaDetails, '_id') && !this.callFromActionPopup) {
        this.processData()
      } else {
        this.selectCountry(this.countrySelected);
        this.selecsecondtCountry(this.secondcountrySelected);   

      }

      setTimeout(() => {
        this.getCompanyDetails();
      }, 100)


    });

    this.$store
      .dispatch("getmasterdata", "education_types")
      .then((response) => {
        this.education_types = response;
        this.masterEducationsList = response;
        this.educationsList = response;
        //this.upDatehighestDegree();
      });


    this.$store
      .dispatch("getmasterdata", "lca_inventory_status")
      .then(response => {
        this.lcastatuses = _.filter(response, function (item) {
          return item.id == 2 || item.id == 3;
        });
      });
    this.getSalary_wiseLavel();
    this.init();

    const $ = JQuery;
    $('form').on('focus', ':input', function () {
      $(this).attr('autocomplete', 'off');
      $(this).attr('autocorrect', 'off');


    });
    $('form').on('click', ':input', function () {
      $(this).attr('autocomplete', 'off');
      $(this).attr('autocorrect', 'off');

    });

    setTimeout(() => {


      if (this.checkProperty(this.getLcaDetails, '_id')) {
        this.fileUploaded = true;
      }
      this.getGlobalConfigDetails();
    }, 100);
    this.tempLcaId = '';
    setTimeout(()=>{
      if(this.checkProperty(this.getLcaDetails, '_id')){
          this.tempLcaId = this.checkProperty(this.getLcaDetails, '_id')
        }
    },10)

  },





};
</script>